import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/inbox.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Avatar from "../../assets/images/avatar.svg";
import Alert from "../../assets/images/alert-circle.svg";
import Download from "../../assets/images/download.svg";
import Trash from "../../assets/images/trash.svg";
import filetext from "../../assets/images/file-text 2.svg";
import Contact from "../../assets/images/contact2.svg";
import Call from "../../assets/images/call.svg";
import Msg from "../../assets/images/msg.svg";
import Mail from "../../assets/images/mail.svg";
import Send from "../../assets/images/send.svg";
import Archive from "../../assets/images/Archive.svg";
import RedAlert from "../../assets/images/red-alert.png";
import AvenuChatbot from "../../assets/images/AvenuChatbot.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { API } from "../../config/api";
import arrowup from "../../assets/images/arrow-up.png";
import downarrow from "../../assets/images/down.png";
import { ApiHelper } from "../../helpers/ApiHelper";
import Messageicon from "../../assets/images/message-g-icon.png";
import Add from "../../assets/images/add.svg";
import Close from "../../assets/images/X.svg";
import Search from "../../assets/images/Search.svg";
import Spinner from "../../components/Spinner";
import MiniSpinner from "../../components/MiniSpinner";
import sdot from "../../assets/images/sdot.svg";
import File from "../../assets/images/file.svg";
import Folder from "../../assets/images/folder.svg";
import Addnow from "../../assets/images/plus-circle.png";
import sample from "../../assets/images/samplefile.png";
import Alerts from "../../assets/images/alert-triangle.svg";
import uploadicon from "../../assets/images/UL.svg";
import downloadicon from "../../assets/images/DL.svg";

import axios from "axios";

import Infos from "../../assets/images/info-b.svg";
import Successful from "../../assets/images/excla-icon-green-now.svg";
import Approved from "../../assets/images/blue-tick-icon.svg";
import Pending from "../../assets/images/pending.svg";
import Modal from "react-modal";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { useLocation, useNavigate } from "react-router";
import Form from "react-bootstrap/Form";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Delete, Edit, TramSharp } from "@material-ui/icons";
import closex from "../../assets/images/X.svg";
import Serachg from "../../assets/images/Search-Icon-grey.svg";
import tagAdd from "../../assets/images/plus-circle.png";
import Grouplogo from "../../assets/images/chat-logo.png";
import Editic from "../../assets/images/edit_ic.svg";
import UserChecked from "../../assets/images/user-check 2.svg";
import NotSend from "../../assets/images/not-send.svg";
import documentimage from "../../assets/images/file-plus.svg";
import pauseimage from "../../assets/images/pause-circle 1.svg";
import onboardingimage from "../../assets/images/status1.svg";
import rejectimage from "../../assets/images/status3.svg";
import Menu from "../../assets/images/menu.svg";
import resumeimage from "../../assets/images/resume.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { width } from "@material-ui/system";
import { end } from "@popperjs/core";
import downarrows from "../../assets/images/dropdown.svg";
import caseimg from "../../assets/images/caseimg.svg";
import caselogo from "../../assets/images/caselogo.png";
import trash from "../../assets/images/trash.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";
// import ModalAlert from "https://cdn.skypack.dev/react-modal@3.16.1";

const AllApplications = () => {
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [miniLoader, setMiniLoader] = useState(false);
  const navigate = useNavigate();
  const [applicants, setApplicants] = useState([]);
  const [profileDetails, setProfileDetails] = useState({});
  const [chatbotsAnwers, setChatbotsAnwers] = useState([]);
  const [status, setStatus] = useState("");
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [istag, isSetTag] = useState(false);
  const [comment, setComments] = useState([]);
  const [editComment, setEditComment] = useState(false);
  const [filterState, setFilterState] = useState("");
  const [jobs, setJobs] = useState([]);
  const [filterJob, setFilterJob] = useState(0);
  const [filterCompany, setFilterCompany] = useState(0);
  const [filterDate, setFilterDate] = useState("");
  const [addCandidateOpen, setAddCandidateOpen] = useState(false);
  const [candidateJobId, setCandidateJobId] = useState(null);
  const [candidateJobName, setCandidateJobName] = useState("");
  const [candidateFirstName, setCandidateFirstname] = useState("");
  const [candidateLastName, setCandidateLastname] = useState("");
  const [candidateEmail, setCandidateEmail] = useState("");
  const [candidatePhone, setCandidatePhone] = useState("");
  const [error, setError] = useState(false);
  const [offset, setOffset] = useState(0);
  const [onBorardingStatus, setOnBoardingStatus] = useState([]);
  const [otherForms, setOtherForms] = useState([]);
  const [applicationHistory, setApplicationHistory] = useState([]);
  const [index, setIndex] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [userId, setUserId] = useState("");
  const [formErr, setFormErr] = useState(false);
  const [phoneErr, setPhoneErr] = useState(false);
  const [phoneExist, setPhoneExist] = useState(false);
  const [recDocs, setRecDocs] = useState([]);
  const [statusOptions, setStatusOptions] = useState([
    {
      id: 1,
      label: "Onboarding",
      value: "onboarding",
    },
    {
      id: 2,
      label: "Pause",
      value: "paused",
    },
    {
      id: 3,
      label: "Archive",
      value: "archive",
    },
    {
      id: 4,
      label: "My Team",
      value: "myteam",
    },
    {
      id: 5,
      label: "Cancel",
      value: "rejected",
    },
  ]);
  const [isSendForm, setIsSendForms] = useState(false);
  const [sendFormMessage, setSendFormMessage] = useState("");
  const [isMyTeamPage, setIsMyTeamPage] = useState(false);
  const [candidateIdList, setCandidateIdList] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("default");
  const [showAlert, setShowAlert] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [documents, setDocuments] = useState([]);
  const [doc, setDoc] = useState("");
  const [usersLength, setUsersLength] = useState(null);
  const [emailError, setEmailError] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isUpload, setIsUpload] = useState(false);
  const [message, setMessage] = useState("");
  const [rsTab, setRsTab] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [deletePopupData, setDeletePopupData] = useState();
  const [documentType, setDocumentType] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [mailStatus, setMailStatus] = useState(true);
  const [company, setCompany] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [archiveModal, setArchiveModal] = useState(false);
  const [onClickToggle, setOnClickToggle] = useState(false);
  const [onClickIndex, setOnClickIndex] = useState(null);
  const [onClickHistoryToggle, setOnClickHistoryToggle] = useState(false);
  const [onClickHistoryIndex, setOnClickHistoryIndex] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  // const [method, setMethod]=useState('');
  const fileInputRef = useRef(null);
  const [editName, setEditName] = useState(false);
  const [editLastName, setEditLastName] = useState(false);
  const [editPhone, setEditPhone] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [reportName, setReportName] = useState("");
  const [reportLastName, setReportLastName] = useState("");
  const [reportPhone, setReportPhone] = useState("");
  const [reportEmail, setReportEmail] = useState("");
  const [isMyteam, setIsMyteam] = useState(false);
  const [messages, setMessages] = useState([]);
  const [textMessage, setTextMessage] = useState("");
  const [messageCount, setMessageCount] = useState([]);
  const lastMessageRef = useRef(null);
  const prevMessagesRef = useRef([]);
  const candidateDetails = useRef(null);
  const [isConversationModalOpen, setIsConversationModalOpen] = useState(false);
  const [conversationModalData, setConversationModalData] = useState(null);
  const [isMultipleChangeModalOpen, setIsMultipleChangeModalOpen] =
    useState(false);
  const [isMultipleArchiveModalOpen, setIsMultipleArchiveModalOpen] =
    useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [caseId, setCaseId] = useState("");
  const [caseDetails, setCaseDetails] = useState({});
  const [listA, setListA] = useState([]);
  const [listB, setListB] = useState([]);
  const [listC, setListC] = useState([]);
  const [onboardingTemplates, setOnboardingTemplates] = useState([]);
  const [templateId, setTemplateId] = useState(0);
  const [myteamFilter, setMyteamFilter] = useState("");
  const [deleteSectionModal, setSectionDeleteModal] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [isApproveShow, setIsApproveShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalIsOpen, setIsOpen] = useState(false);
  const [tempId, setTempId] = useState(0);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  function closeModal() {
    setTempId(0);
    setIsOpen(false);
  }

  useEffect(() => {
    console.log("DEtails", caseDetails);
    if (caseDetails?.citizenship_status_code !== undefined) getListValues();
  }, [caseDetails]);

  const getListValues = async () => {
    await ApiHelper.post(API.getI9DocTypes, {
      citizenship_status_code: caseDetails?.citizenship_status_code,
      document_category: "LIST_A",
    }).then((res) => {
      console.log(res);
      setListA(res?.data?.ListA?.document_typess);
      // });
      // await ApiHelper.post(API.getI9DocTypes, {
      //   citizenship_status_code: caseDetails?.citizenship_status_code,
      //   document_category: "LIST_B",
      // }).then((res) => {
      //   console.log(res);
      setListB(res?.data?.ListB?.document_types);
      // });
      // await ApiHelper.post(API.getI9DocTypes, {
      //   citizenship_status_code: caseDetails?.citizenship_status_code,
      //   document_category: "LIST_C",
      // }).then((res) => {
      //   console.log(res);
      setListC(res?.data?.ListC?.document_types);
    });
  };

  useEffect(() => {
    if (location.pathname === "/dashboard/candidates") {
      setIsMyTeamPage(false);
      setFilterState("hire");
      setOffset(0);
      setFilterJob(0);
      setFilterCompany(0);
      setCandidateJobId(0);
      setCandidateJobName("");
      let userData = JSON.parse(localStorage.getItem("UserAccess"));
      setJobs(userData?.Chatbots);
      setCandidateJobId(userData?.Chatbots[0]?.id);
      setCandidateJobName(userData?.Chatbots[0]?.chatbot_name);
      setCompany(userData?.Companies);
      fetchOnboardingTemplates();
      getUserId();
    }
    if (location.pathname === "/dashboard/onboarding/my-team") {
      setIsMyTeamPage(true);
      setOffset(0);
      let userData = JSON.parse(localStorage.getItem("UserAccess"));
      setFilterState("myteam");
      setFilterJob(0);
      setFilterCompany(0);
      setCandidateJobId(0);
      setCandidateJobName("");
      setJobs(userData?.Chatbots);
      setCandidateJobId(userData?.Chatbots[0]?.id);
      setCandidateJobName(userData?.Chatbots[0]?.chatbot_name);
      setCompany(userData?.Companies);
      fetchOnboardingTemplates();
      fetchMyTeam();
    }
  }, [location]);

  function getUserId() {
    let user = JSON.parse(localStorage.getItem("UserData"));
    setUserId(user.id);
  }

  useEffect(() => {
    setInterval(() => {
      let user = JSON.parse(localStorage.getItem("UserData"));
      fetchMessageCount(user?.id);
    }, 5000);
  }, []);

  // useEffect(() => {
  //   if (profileDetails) {
  //     fetchOnboardingStatus();
  //     fetchDocuments();
  //   }
  // }, [profileDetails]);
  async function getCandidateCaseData() {
    setMiniLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      caseId: caseId,
    };
    await ApiHelper.post(API.caseDetails, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.status === 200) {
          setCaseDetails(resData?.data);
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setMiniLoader(false);
      });
  }

  async function fetchOnboardingStatus(id) {
    setMiniLoader(true);
    const obj = {
      intervieweeid: id,
    };
    await ApiHelper.post(API.fetchOnboardingStatus, obj)
      .then((resData) => {
        console.log(resData);
        let isApprove = true;
        let isApproveShow = false;
        if (resData?.data?.success === true) {
          setOnBoardingStatus(resData.data?.data);
          setOtherForms(resData.data?.otherforms);
          for (let i = 0; i <= resData.data?.data?.length - 1; i++) {
            if (resData.data?.data[i]?.section_status !== "Confirmed") {
              setIsMyteam(false);
            } else {
              setIsMyteam(true);
            }
          }
          for (let i = 0; i <= resData.data?.data?.length - 1; i++) {
            if (
              resData.data?.data[i]?.section_status !== "Success" &&
              resData.data?.data[i]?.section_status !== "Confirmed"
            ) {
              isApprove = false;
            }
            if (resData.data?.data[i]?.section_status !== "Confirmed") {
              isApproveShow = true;
            }
          }
          for (let i = 0; i <= resData.data?.otherforms?.length - 1; i++) {
            if (
              resData.data?.otherforms[i]?.section_status !== "Success" &&
              resData.data?.otherforms[i]?.section_status !== "Confirmed"
            ) {
              isApprove = false;
            }
            if (resData.data?.otherforms[i]?.section_status !== "Confirmed") {
              isApproveShow = true;
            }
          }
          console.log(isApprove, isApproveShow);
          setIsApprove(isApprove);
          setIsApproveShow(isApproveShow);
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setMiniLoader(false);
      });
  }
  async function fetchApplicationHistory(id, ownerid) {
    setMiniLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      intervieweeid: id,
      ownerid: ownerid,
      userid: user.id,
    };
    await ApiHelper.post(API.fetchApplicationHistory, obj)
      .then((resData) => {
        console.log(resData);
        if (resData.status === 200) {
          setApplicationHistory(resData?.data?.data);
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setMiniLoader(false);
      });
  }

  const fetchJobs = async () => {
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
    };
    await ApiHelper.post(API.getJobs, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setJobs(resData.data.data);
          setCandidateJobId(resData?.data?.data[0]?.id);
          setCandidateJobName(resData?.data?.data[0]?.chatbot_name);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const fetchCompanyList = async () => {
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
    };
    await ApiHelper.post(API.getCompanyList, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.status === 200) {
          setCompany(resData?.data?.Companies);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const fetchDocuments = async () => {
    setMiniLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      intervieweeid: profileDetails.id,
    };
    await ApiHelper.post(API.getDocuments, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setRecDocs(
            JSON.parse(resData?.data?.RecruitmentUploads[0]?.note_files_path)
          );
          setDocuments(resData?.data);
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        setMiniLoader(false);
      });
  };

  const fetchAllCandidatesData = async () => {
    setLoader(true);

    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      offset: 0,
      limit: 30,
      filterkey: filterState,
    };
    const obj = {
      userid: user?.id,
      chatbotId: parseInt(filterJob),
      companyId: parseInt(filterCompany),
      datefilter: filterDate,
      offset: 0,
      limit: 30,
      filterkey: filterState,
      searchkey: searchText,
    };
    try {
      const resData = await ApiHelper.post(API.getAllApplications, obj);
      if (resData.status === 200) {
        //     if (filterState === 'all') {
        console.log(resData);
        let array;
        array = resData.data?.interviewes_list;
        if (resData.data?.interviewes_list[0] !== undefined) {
          // setUsersLength(array?.length);
          setApplicants(array);
          // setCompanyName(
          //   resData.data?.interviewes_list[0]?.chatbot?.customuser?.company_name
          // );
        } else {
          setApplicants(array);
          setProfileDetails({});
        }
        setLoader(false);
      }
      setOffset(0);
    } catch (err) {
      setLoader(false);
    }
    setLoader(false);
  };

  const fetchAllApplications = async () => {
    setLoader(true);

    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      offset: 0,
      limit: 30,
      filterkey: filterState,
    };
    const obj = {
      userid: user?.id,
      chatbotId: parseInt(filterJob),
      companyId: parseInt(filterCompany),
      datefilter: filterDate,
      offset: 0,
      limit: 30,
      filterkey: filterState,
      searchkey: searchText,
    };
    try {
      const resData = await ApiHelper.post(API.getAllApplications, obj);
      if (resData.status === 200) {
        console.log(resData);
        let array;
        array = resData.data?.interviewes_list;
        setTotalCount(resData.data?.total_count);
        if (resData.data?.interviewes_list[0] !== undefined) {
          setUsersLength(array?.length);
          setApplicants(array);
          setCompanyName(
            resData.data?.interviewes_list[0]?.chatbot?.customuser?.company_name
          );
          setCaseId(resData.data?.interviewes_list[0]?.e_verify_casId);
          setProfileDetails(resData.data?.interviewes_list[0]);
          candidateDetails.current = resData.data?.interviewes_list[0];
          localStorage.setItem(
            "selectedCandidate",
            resData.data?.interviewes_list[0].first_name
          );
          localStorage.setItem(
            "candidateChatbotId",
            resData.data?.interviewes_list[0]?.chatbot?.id
          );
          setCurrentStatus(candidateDetails.current?.onboarding_status);
        } else {
          setApplicants(array);
          setProfileDetails({});
        }
        setLoader(false);
      }
      setOffset(0);
    } catch (err) {
      setLoader(false);
    }
    setLoader(false);
  };

  // Group using Map
  const groupMap = new Map();

  otherForms.forEach((item) => {
    const group = groupMap.get(item.template_id) || [];
    group.push(item);
    groupMap.set(item.template_id, group);
  });

  const reviewCandidate = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    let isOnboarding = localStorage.getItem("isOnboarding");
    console.log(isOnboarding, tempId);
    const obj = {
      userid: user.id,
      intervieweeid: profileDetails?.id,
      name: user?.first_name,
    };
    const formData = {
      userid: user.id,
      intervieweeid: profileDetails?.id,
      name: user?.first_name,
      template_id: tempId,
    };
    await ApiHelper.post(
      API.reviewCandidate,
      isOnboarding === "true" ? obj : formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          toast("Moved to My Team", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTempId(0);
          fetchAllApplications();
          fetchOnboardingStatus(profileDetails?.id);
          setIsOpen(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const fetchMyTeam = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      chatbot_id: parseInt(filterJob),
      companyId: parseInt(filterCompany),
      status: myteamFilter,
      offset: 0,
      limit: 30,
      searchkey: searchText,
    };
    try {
      const resData = await ApiHelper.post(API.fetchMyTeam, obj);
      if (resData.status === 200) {
        console.log(resData);
        let array;
        array = resData.data?.list;
        setTotalCount(resData.data?.totalcount);
        if (resData.data?.list[0] !== undefined) {
          setUsersLength(array?.length);
          setApplicants(array);
          setCompanyName(
            resData.data?.list[0]?.chatbot?.customuser?.company_name
          );
          setCaseId(resData.data?.list[0]?.e_verify_casId);
          setProfileDetails(resData?.data?.list[0]);
          candidateDetails.current = resData.data?.list[0];
          localStorage.setItem(
            "selectedCandidate",
            resData.data?.list[0].first_name
          );
          localStorage.setItem(
            "candidateChatbotId",
            resData.data?.list[0]?.chatbot?.id
          );
          setCurrentStatus(candidateDetails.current?.onboarding_status);
        } else {
          setApplicants(array);
          setProfileDetails({});
        }
        setLoader(false);
      }
      setOffset(0);
    } catch (err) {
      setLoader(false);
    }
    setLoader(false);
  };

  const fetchChatbotAnswers = async (chatbotid, id) => {
    setMiniLoader(true);
    const formData = {
      chatbotid: chatbotid,
      intervieweeid: id,
    };
    await ApiHelper.post(API.getChatbotsAnwers, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.status === 200) {
          setChatbotsAnwers(resData?.data?.data);
          // for(let i=0; i<resData?.data?.data.length;i++){
          // if(resData?.data?.data[i]?.column_name==="Otp Method"){
          //  method.current= resData?.data?.data[i]?.answer_text
          // }}
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        setMiniLoader(false);
      });
  };

  useEffect(() => {
    // Scroll to the last message when messages change
    console.log("Executed", lastMessageRef);
    if (lastMessageRef?.current) {
      console.log(lastMessageRef?.current);
      lastMessageRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
  }, [messages]);

  // const fetchMessagesForFirst = async (id) => {
  //   // setMiniLoader(true);
  //   await ApiHelper.post(API.getMessages+id)
  //     .then((resData) => {
  //       console.log(resData);
  //       if (resData.status === 200) {
  //         if(messages!==resData?.data?.data){
  //         setMessages(resData?.data?.data);
  //         }
  //         const element = document.getElementById(resData?.data?.data?.chats?.length-1);
  //         setTimeout(()=>{
  //           console.log(element)
  //           if (element) {
  //             element.scrollIntoView({ behavior: 'auto', block:'start' });
  //           }
  //         },5000)
  //         // for(let i=0; i<resData?.data?.data.length;i++){
  //         // if(resData?.data?.data[i]?.column_name==="Otp Method"){
  //         //  method.current= resData?.data?.data[i]?.answer_text
  //         // }}
  //         setMiniLoader(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setMiniLoader(false);
  //     });
  // };

  const fetchMessages = async (id) => {
    // setMiniLoader(true);
    await ApiHelper.post(API.getMessages + id)
      .then((resData) => {
        console.log(resData);
        console.log(JSON.stringify(prevMessagesRef.current));
        console.log(JSON.stringify(resData?.data?.data?.chats));
        if (resData.status === 200) {
          if (
            JSON.stringify(prevMessagesRef.current) !==
            JSON.stringify(resData?.data?.data?.chats)
          ) {
            console.log("sett");
            setMessages(resData?.data?.data?.chats);
            prevMessagesRef.current = resData?.data?.data?.chats;
          }
          // for(let i=0; i<resData?.data?.data.length;i++){
          // if(resData?.data?.data[i]?.column_name==="Otp Method"){
          //  method.current= resData?.data?.data[i]?.answer_text
          // }}
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        setMiniLoader(false);
      });
  };
  // const fetchNewMessages = async (id) => {
  //   // setMiniLoader(true);
  //   await ApiHelper.post(API.getNewMessages+id)
  //     .then((resData) => {
  //       console.log(resData);
  //       if (resData.status === 200) {
  //         setMessages(resData?.data?.data);
  //         // for(let i=0; i<resData?.data?.data.length;i++){
  //         // if(resData?.data?.data[i]?.column_name==="Otp Method"){
  //         //  method.current= resData?.data?.data[i]?.answer_text
  //         // }}
  //         setMiniLoader(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setMiniLoader(false);
  //     });
  // };
  const fetchMessageCount = async (id) => {
    // setMiniLoader(true);
    await ApiHelper.post(API.getMessageCount + id)
      .then((resData) => {
        // console.log(resData);
        if (resData.status === 200) {
          if (messageCount !== resData?.data?.data)
            setMessageCount(resData?.data?.data);
          // for(let i=0; i<resData?.data?.data.length;i++){
          // if(resData?.data?.data[i]?.column_name==="Otp Method"){
          //  method.current= resData?.data?.data[i]?.answer_text
          // }}
          setMiniLoader(false);
        }
      })
      .catch((err) => {
        setMiniLoader(false);
      });
  };
  const sendMessage = async (id) => {
    let user = JSON.parse(localStorage.getItem("UserData"));
    if (textMessage !== "") {
      setMiniLoader(true);
      const formData = {
        message: textMessage,
        interviewId: id,
        sender_user_id: user?.id,
      };
      await ApiHelper.post(API.sendMessage, formData)
        .then((resData) => {
          console.log(resData);
          if (resData.status === 200) {
            setTextMessage("");
            fetchMessages(id);
            // for(let i=0; i<resData?.data?.data.length;i++){
            // if(resData?.data?.data[i]?.column_name==="Otp Method"){
            //  method.current= resData?.data?.data[i]?.answer_text
            // }}
            setMiniLoader(false);
          }
        })
        .catch((err) => {
          setMiniLoader(false);
        });
    }
  };

  const setProfile = (item) => {
    // setLoader(true);
    setCurrentStatus(item?.onboarding_status);
    localStorage.setItem("profile", JSON.stringify(item));
    setProfileDetails(item);
    setStatus(
      item?.note_status_dropdown !== null && item?.note_status_dropdown
    );
    setTags(
      item?.note_tags !== null
        ? item?.note_tags
            .replace(/[^a-z,^A-Z,0-9,' ']/g, "")
            ?.split(/[.,!,?,;]/)
        : []
    );
    setComments(item?.note_comment);
    setLoader(false);
  };

  const checkStatus = async (status) => {
    setMailStatus(true);
    if (status === "default") {
      return;
    }
    if (status === "onboarding") {
      setMessage(
        "Congratulations on your new position at " +
          companyName +
          ". To start the onboarding process, please click the button below."
      );
    }
    if (status === "resendonboarding") {
      setMessage(
        "Congratulations on your new position at " +
          companyName +
          ". To start the onboarding process, please click the button below."
      );
    }
    if (status === "resumed") {
      setMessage(
        "Your employer has resumed your onboarding process. If you have any questions, please contact " +
          companyName +
          "."
      );
    }
    if (status === "paused") {
      setMessage(
        "Your employer has paused your onboarding process. If you have any questions, please contact " +
          companyName +
          "."
      );
    }
    if (status === "rejected") {
      setMessage(
        "Your employer has canceled your onboarding process. If you have any questions, please contact " +
          companyName +
          "."
      );
    }
    if (status === "archive") {
      setMessage(
        "Are you sure you want to archive this employee? By archiving this employee, they will no longer be available on the employee list."
      );
    }
    if (status === "unarchive") {
      setMessage(
        "Are you sure you want to unarchive this employee? By unarchiving this employee, they will be available on the employee list."
      );
    }
    setNewStatus(status);
    setShowAlert(true);
  };

  async function updateStatus(value) {
    setLoader(true);
    let idArray = [];
    console.log(candidateIdList);
    if (value === 1) {
      for (let i = 0; i < candidateIdList.length; i++) {
        idArray.push({
          intervieweeid: candidateIdList[i],
        });
      }
    }
    console.log(idArray);
    const formData = {
      userid: userId,
      intervieweeid:
        value === 0
          ? [{ intervieweeid: profileDetails.id.toString() }]
          : idArray,
      onboarding_status: newStatus,
      templateid: templateId,
      message: message,
      mailstatus: newStatus === "unarchive" ? 0 : mailStatus === true ? 1 : 0,
    };
    console.log(formData);
    await ApiHelper.post(API.updateStatus, formData)
      .then((resData) => {
        console.log(resData);
        if (value === 0) {
          if (resData.data.success === true) {
            setTemplateId(0);
            if (newStatus === "unarchive") {
              setArchiveModal(false);
              fetchAllApplications();
            }
            if (newStatus === "myteam") {
              setArchiveModal(false);
              setIsMultipleArchiveModalOpen(false);
              fetchAllApplications();
            } else {
              setCurrentStatus(newStatus);
              setMessage("");
              fetchSingleApplicant(profileDetails.id);
              fetchOnboardingStatus(profileDetails.id);
              setLoader(false);
              setShowAlert(false);
            }
          }
          if (resData.data.success === false) {
            toast(resData?.data?.message, {
              position: "top-right",
              fontSize: "15px",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setArchiveModal(false);
            setMessage("");
            setLoader(false);
            setShowAlert(false);
          }
        } else {
          if (resData.data.success === true) {
            fetchAllApplications();
            setTemplateId(0);
            setCandidateIdList([]);
            fetchOnboardingStatus(profileDetails.id);
            setIsMultipleChangeModalOpen(false);
          }
          if (resData.data.success === false) {
            toast("No Valid Onboarding Forms !", {
              position: "top-right",
              fontSize: "15px",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setArchiveModal(false);
            setMessage("");
            setLoader(false);
            setShowAlert(false);
            setIsMultipleChangeModalOpen(false);
          }
        }
      })
      .catch((err) => {
        setLoader(false);
        setArchiveModal(false);
        setIsMultipleChangeModalOpen(false);
        setShowAlert(false);
        console.log(err);
      });
  }

  async function sendForms(value) {
    setLoader(true);
    let idArray = [];
    console.log(candidateIdList);
    let user = JSON.parse(localStorage.getItem("UserData"));
    if (value === 1) {
      for (let i = 0; i < candidateIdList.length; i++) {
        idArray.push({
          intervieweeid: candidateIdList[i],
        });
      }
    }
    console.log(idArray);
    const formData = {
      intervieweeid:
        value === 0
          ? [{ intervieweeid: profileDetails.id.toString() }]
          : idArray,
      templateid: templateId,
      message: sendFormMessage,
      mailstatus: 1,
    };
    console.log(formData);
    await ApiHelper.post(API.sendForms, formData)
      .then((resData) => {
        console.log(resData);
        // if (value === 0) {
        if (resData.data.success === true) {
          setTemplateId(0);
          setSendFormMessage("");
          setIsSendForms(false);
          fetchOnboardingStatus(profileDetails.id);
          setLoader(false);
        } else {
          toast(resData?.data?.message, {
            position: "top-right",
            fontSize: "15px",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoader(false);
        }
        // }
        // else {
        //   if (resData.data.success === true) {
        //     fetchAllApplications();
        //     setTemplateId(0);
        //     setCandidateIdList([]);
        //     fetchOnboardingStatus(profileDetails.id);
        //     setIsMultipleChangeModalOpen(false);
        //   }
        //   if (resData.data.success === false) {
        //     toast("No Valid Onboarding Forms !", {
        //       position: "top-right",
        //       fontSize: "15px",
        //       autoClose: 5000,
        //       hideProgressBar: true,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       draggable: true,
        //       progress: undefined,
        //       theme: "light",
        //     });
        //     setArchiveModal(false);
        //     setMessage("");
        //     setLoader(false);
        //     setShowAlert(false);
        //     setIsMultipleChangeModalOpen(false);
        //   }
        // }
      })
      .catch((err) => {
        setLoader(false);
        setArchiveModal(false);
        setIsMultipleChangeModalOpen(false);
        setShowAlert(false);
        console.log(err);
      });
  }
  const addTags = async (event) => {
    if (event.key === "Enter") {
      setLoader(true);
      let tag = [...tags, newTag];
      setTags(tag);
      const formData = {
        userid: userId,
        intervieweeid: profileDetails.id,
        note_tags: tag.toString(),
      };
      await ApiHelper.post(API.updateApplicants, formData)
        .then((resData) => {
          if (resData.data.success === true) setNewTag("");
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
        });
    }
  };

  const addTagsOnBlur = async (event) => {
    setLoader(true);
    let tag = [...tags, newTag];
    setTags(tag);
    const formData = {
      userid: userId,
      intervieweeid: profileDetails.id,
      note_tags: tag.toString(),
    };
    await ApiHelper.post(API.updateApplicants, formData)
      .then((resData) => {
        if (resData.data.success === true) setNewTag("");
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const addComments = async (event) => {
    if (event.key === "Enter") {
      setLoader(true);
      const formData = {
        userid: userId,
        intervieweeid: profileDetails.id,
        note_comment: comment,
      };
      await ApiHelper.post(API.updateApplicants, formData)
        .then((resData) => {
          if (resData.data.success === true) {
            setEditComment(false);
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
        });
    }
  };

  const addCommentsOnBlur = async (event) => {
    setLoader(true);
    const formData = {
      userid: userId,
      intervieweeid: profileDetails.id,
      note_comment: comment,
    };
    await ApiHelper.post(API.updateApplicants, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setEditComment(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const removeTag = async (item, index) => {
    setLoader(true);
    const formData = {
      intervieweeid: profileDetails.id,
      tag: item,
    };
    await ApiHelper.post(API.removeTags, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          fetchSingleApplicant(profileDetails.id);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const fetchSingleApplicant = async (id) => {
    setLoader(true);
    let formData = {
      intervieweeid: id,
    };
    if (isMyTeamPage) {
      formData.status = "myteam";
    }
    await ApiHelper.post(API.getApplicantsbyId, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setTags(
            resData.data?.interview_data?.note_tags !== null
              ? resData.data?.interview_data?.note_tags
                  .replace(/[^a-z,^A-Z,0-9,' ']/g, "")
                  ?.split(/[.,!,?,;]/)
              : []
          );
          setComments(resData.data?.interview_data?.note_comment);

          // candidateDetails.current = resData.data?.interview_data;
          // setCompanyName(
          //   resData.data?.interview_data?.chatbot?.customuser?.company_name
          // );
          // localStorage.setItem(
          //   "selectedCandidate",
          //   resData.data?.interview_data?.first_name
          // );
          // localStorage.setItem(
          //   "candidateChatbotId",
          //   resData.data?.interview_data?.chatbot?.id
          // );
          setProfileDetails(resData.data?.interview_data);
          // setTags(
          //   resData.data?.interview_data?.note_tags !== null
          //     ? resData.data?.interview_data?.note_tags
          //         .replace(/[^a-z,^A-Z,0-9,' ']/g, "")
          //         ?.split(/[.,!,?,;]/)
          //     : []
          // );
          // setComments(resData.data?.interview_data?.note_comment);
          // setCurrentStatus(resData.data?.interview_data?.onboarding_status);
          // setProfile(resData.data.interview_data);
          // setTags(resData.data.interview_data.note_tags !== null ? resData.data.interview_data.note_tags.replace(/[^a-z,]/g, '').split(/[.,!,?,;]/) : [])
          // console.log(resData.data.interview_data.note_tags !== null ? resData.data.interview_data.note_tags.replace(/[^a-z,]/g, '').split(/[.,!,?,;]/) : [])
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  // useEffect(() => {
  //   fetchAllApplications();
  // }, [filterJob, filterState]);

  useEffect(() => {
    // if (isMyTeamPage === false) {
    if (parseInt(filterCompany) !== 0) {
      fetchCompanyJobs();
    }
    if (parseInt(filterCompany) === 0) {
      let userData = JSON.parse(localStorage.getItem("UserAccess"));
      setJobs(userData?.Chatbots);
    }
    // }
  }, [filterCompany]);

  // useEffect(() => {
  //   if (filterCompany !== 0) {
  //     if (jobs[0]?.id !== undefined) {
  //       setFilterJob(jobs[0]?.id)
  //     }
  //   }
  // }, [jobs])

  const fetchCompanyJobs = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      companyId: filterCompany,
    };
    await ApiHelper.post(API.getCompanyJobs, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setJobs(resData.data.data);
          setCandidateJobId(resData?.data?.data[0]?.id);
          setCandidateJobName(resData?.data?.data[0]?.chatbot_name);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  useEffect(() => {
    setLoader(true);
    const mappedJobs = jobs?.map((job) => {
      return job;
    });

    for (let i = 0; i < mappedJobs?.length; i++) {
      if (mappedJobs[i]?.id == candidateJobId) {
        setCandidateJobName(mappedJobs[i]?.chatbot_name);
        break;
      }
    }
    setLoader(false);
  }, [candidateJobId]);

  const emailValidate = async (jobId, email) => {
    // if (!/^\S+@\S+\.\S+$/.test(candidateEmail)) {
    //   // Invalid email format, do not make the API call
    //   // setEmailError(true);
    //   return;
    // }
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (regex.test(email)) {
      setIsEmailValid(true);
      setLoader(true);
      const formData = {
        email: email,
        chatbotid: jobId === null ? candidateJobId : jobId,
      };
      await ApiHelper.post(API.checkEmail, formData)
        .then((resData) => {
          console.log(resData);
          if (resData?.data.success === true) {
            //addCandidate();
            setEmailError(false);
            setLoader(false);
          } else {
            setEmailError(true);
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      setIsEmailValid(false);
      setEmailError(false);
    }
  };

  const phoneValidate = async (jobId, phone) => {
    // if (!/^\S+@\S+\.\S+$/.test(candidateEmail)) {
    //   // Invalid email format, do not make the API call
    //   // setEmailError(true);
    //   return;
    // }
    setLoader(true);
    const formData = {
      phone: phone,
      chatbotid: jobId === null ? candidateJobId : jobId,
    };
    await ApiHelper.post(API.checkPhone, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.data.success === true) {
          //addCandidate();
          setPhoneExist(false);
          setLoader(false);
        } else {
          setPhoneExist(true);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const addCandidate = async () => {
    if (
      candidateFirstName.trim() === "" ||
      candidateLastName.trim() === "" ||
      candidatePhone === "" ||
      candidateEmail === ""
    ) {
      setError(true);
    } else {
      if (
        phoneErr !== true &&
        emailError !== true &&
        isEmailValid === true &&
        phoneExist !== true
      ) {
        setLoader(true);
        // setAddCandidateOpen(false);
        let user = JSON.parse(localStorage.getItem("UserData"));
        let obj = {
          chatbotid: candidateJobId,
          chatbotname: candidateJobName,
          email: candidateEmail,
          firstname: candidateFirstName,
          lastname: candidateLastName,
          phonenumber: candidatePhone,
          userid: user?.id,
        };
        const formData = new FormData();
        formData.append("chatbotid", candidateJobId);
        formData.append("firstname", candidateFirstName);
        formData.append("lastname", candidateLastName);
        formData.append("email", candidateEmail);
        formData.append("phonenumber", candidatePhone);
        formData.append("chatbotname", candidateJobName);
        await ApiHelper.post(
          isMyTeamPage ? API.addCandidateToMyTeam : API.addCandidate,
          isMyTeamPage ? obj : formData
        )
          .then((resData) => {
            if (resData.data.success === true) {
              toast("Candidate Added!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setAddCandidateOpen(false);
              isMyTeamPage ? fetchMyTeam() : fetchAllApplications();
              // setFilterJob(candidateJobId)
              setCandidateFirstname("");
              setCandidateLastname("");
              setCandidatePhone("");
              setCandidateEmail("");
              setError(false);
              setFormErr(false);
              setLoader(false);
            }

            if (resData.data.success === false) {
              toast(resData?.data?.message, {
                className: "toast-message",
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setFormErr(true);
              setError(false);
              setLoader(false);
            }
          })
          .catch((err) => {
            toast("Server Error!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setAddCandidateOpen(false);
            setLoader(false);
            setError(false);
          });
      }
    }
  };

  const validatePhone = (phone) => {
    const cleanedPhone = phone; // Remove non-digit characters

    if (/^[+]{1}[0-9]{11,12}$/.test(cleanedPhone)) {
      // Check if the cleaned phone number contains only digits
      phoneValidate(null, candidatePhone);

      setPhoneErr(false); // Show an error if it's not 10 digits
    } else if (cleanedPhone.length === 10) {
      // If the cleaned phone number has 10 digits, add the +1 country code
      setCandidatePhone("+1" + cleanedPhone);
      phoneValidate(null, candidatePhone);
      setPhoneErr(false); // Reset the error
    } else {
      setPhoneExist(false);
      setPhoneErr(true); // Show an error if it contains non-digit characters
    }
  };
  const colorMap = {};
  const selectedColors = {};

  const generateColor = () => {
    let randomColorString = "#";
    const arrayOfColorFunctions = "0123456789abcdef";
    for (let x = 0; x < 6; x++) {
      let index = Math.floor(Math.random() * 16);
      let value = arrayOfColorFunctions[index];

      randomColorString += value;
    }
    return randomColorString;
  };

  // const newColorFind = id => {
  //     if (colorMap[id]) return colorMap[id];
  //     let newColor;
  //     do {
  //         newColor = generateColor();
  //     } while (selectedColors[newColor]);
  //     colorMap[id] = newColor;
  //     selectedColors[newColor] = true;
  //     return newColor;
  // }

  // const filterByChatbotId = (array, chatbotId) => {
  //     return array.filter(item => item.chatbot_id === chatbotId);
  // };

  const fetchMoreData = async () => {
    // setLoader(true);

    const updatedOffset = offset + 30;
    setOffset(updatedOffset);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      offset: updatedOffset,
      limit: 30,
      filterkey: filterState,
    };
    const obj = {
      userid: user?.id,
      chatbotId: parseInt(filterJob),
      companyId: parseInt(filterCompany),
      datefilter: filterDate,
      offset: updatedOffset,
      limit: 30,
      filterkey: filterState,
      searchkey: searchText,
    };
    try {
      if (searchText !== "") {
        formData.searchkey = searchText;
        obj.searchkey = searchText;
      }
      const resData = await ApiHelper.post(API.getAllApplications, obj);
      console.log(resData);
      if (resData.status === 200) {
        if (filterState === "all") {
          const array = applicants.concat(resData.data.interviewes_list);
          setTotalCount(resData.data?.total_count);
          setApplicants(array);
          setLoader(false);
        } else {
          let arr = [];
          for (let i = 0; i < resData.data.interviewes_list?.length; i++) {
            if (
              resData.data.interviewes_list[i]?.note_status_dropdown ===
              filterState
            ) {
              arr.push(resData.data.interviewes_list[i]);
            }
          }
          if (arr?.length === 0) {
            setUsersLength(arr?.length);
            setLoader(false);
          } else {
            setUsersLength(arr?.length);
            setApplicants([...applicants, ...arr]);
            setLoader(false);
          }
        }
      }
    } catch (err) {
      setLoader(false);
    }
  };

  const fetchMoreMyTeam = async () => {
    // setLoader(true);

    const updatedOffset = offset + 30;
    setOffset(updatedOffset);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      chatbot_id: parseInt(filterJob),
      status: myteamFilter,
      offset: updatedOffset,
      limit: 30,
      searchkey: searchText,
    };
    try {
      const resData = await ApiHelper.post(API.fetchMyTeam, obj);
      if (resData.status === 200) {
        if (filterState === "all") {
          const array = applicants.concat(resData?.data?.list);
          setTotalCount(resData.data?.totalcount);
          setApplicants(array);
          setLoader(false);
        } else {
          let arr = [];
          for (let i = 0; i < resData.data.list?.length; i++) {
            // if (resData?.data?.list[i]?.note_status_dropdown === filterState) {
            arr.push(resData.data.list[i]);
            // }
          }
          if (arr?.length === 0) {
            setUsersLength(arr?.length);
            setLoader(false);
          } else {
            setUsersLength(arr?.length);
            setApplicants([...applicants, ...arr]);
            setLoader(false);
          }
        }
      }
    } catch (err) {
      setLoader(false);
    }
    setLoader(false);
  };

  // search candidate
  useEffect(() => {
    if (searchText === "") {
      if (filterState !== "") {
        if (location.pathname === "/dashboard/candidates") {
          fetchAllApplications();
        } else {
          fetchMyTeam();
        }
      }
    } else {
      const getData = setTimeout(() => {
        if (filterState !== "") {
          if (location.pathname === "/dashboard/candidates") {
            fetchAllApplications();
          } else {
            fetchMyTeam();
          }
        }
      }, 500);
      return () => {
        clearTimeout(getData);
      };
    }
  }, [searchText]);

  const handleSearch = async (event) => {
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      filter_chatbot_id: filterJob,
      offset: 0,
      searchkey: searchText,
      limit: 10,
      filterkey: filterState,
    };
    const formData = {
      userid: user?.id,
      offset: 0,
      searchkey: searchText,
      limit: 10,
      filterkey: filterState,
    };
    const result = await ApiHelper.post(
      API.getAllApplications,
      filterJob === 0 ? formData : obj
    );
    const data = result?.data?.interviewes_list;
    if (data?.length === 0) {
      setApplicants([]);
      setProfileDetails({});
    } else {
      setApplicants(data);
      setProfile(data[0]);
      fetchChatbotAnswers(data[0]?.chatbot_id, data[0]?.id);
    }
  };

  const archiveEmployee = async (value) => {
    setLoader(true);
    let idArray = [];
    if (value === 1) {
      for (let i = 0; i < candidateIdList.length; i++) {
        idArray.push({
          intervieweeid: candidateIdList[i],
        });
      }
    }
    const formData = {
      interviewid:
        value === 0
          ? [{ intervieweeid: profileDetails.id.toString() }]
          : idArray,
    };
    await ApiHelper.post(API.archiveEmployee, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          fetchAllApplications();
          setCandidateIdList([]);
          setArchiveModal(false);
          setIsMultipleArchiveModalOpen(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const filterByState = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      filter_chatbot_id: filterJob,
      offset: 0,
      limit: 10,
      filterkey: filterState,
    };
    const formData = {
      userid: user?.id,
      offset: 0,
      limit: 10,
      filterkey: filterState,
    };
    const result = await ApiHelper.post(
      API.getAllApplications,
      filterJob === 0 ? formData : obj
    );
    const data = result.data.interviewes_list;
    setApplicants(data);
    setProfile(data[0]);

    setLoader(false);
  };

  // chatbot filter

  useEffect(() => {
    if (location.pathname === "/dashboard/candidates") {
      fetchAllApplications();
    } else {
      fetchMyTeam();
    }
  }, [filterJob, filterCompany, filterDate]);

  useEffect(() => {
    if (location.pathname === "/dashboard/candidates") {
      if (filterState !== "") {
        fetchAllApplications();
      }
    }
  }, [filterState]);

  useEffect(() => {
    if (location.pathname === "/dashboard/onboarding/my-team") {
      fetchMyTeam();
    }
  }, [myteamFilter]);

  const handleTabClick = (index) => {
    setSelectedIndex(index);
  };
  var intervalId;
  function startInterval() {
    intervalId = setInterval(function () {
      fetchMessages(candidateDetails.current?.id);
    }, 3000);
  }
  function stopInterval() {
    clearInterval(intervalId);
  }

  async function fetchOnboardingTemplates() {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      searchkey: "",
    };
    await ApiHelper.post(API.getSectionTemplates, formData)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setOnboardingTemplates(resData?.data?.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }

  async function updateMyTeamStatus(e, id, value) {
    if (e.target.value === "sendforms") {
      setIsSendForms(true);
    } else {
      setLoader(true);
      let idArray = [];
      console.log(candidateIdList);
      if (value === 1) {
        for (let i = 0; i < candidateIdList.length; i++) {
          idArray.push({
            interviewid: candidateIdList[i],
          });
        }
      }
      console.log(idArray);

      const formData = {
        interviewid: value === 0 ? [{ interviewid: id }] : idArray,
        status: e.target.value,
      };
      await ApiHelper.post(API.updatemyTeamApplicantStatus, formData)
        .then((resData) => {
          console.log(resData);
          if (resData?.data?.success === true) {
            value === 1 ? setCandidateIdList([]) : getCandidateData(id);
            fetchMyTeam();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  }

  useEffect(() => {
    console.log(selectedIndex, candidateDetails);
    if (selectedIndex === 0) {
      fetchOnboardingStatus(candidateDetails.current?.id);
    }
    if (selectedIndex === 1) {
      getCandidateCaseData();
    }
    if (selectedIndex === 2) {
      fetchApplicationHistory(
        candidateDetails.current?.id,
        candidateDetails.current?.chatbot?.owner_id
      );
    }
    if (selectedIndex === 3) {
      fetchDocuments();
    }
    if (selectedIndex === 4) {
      fetchChatbotAnswers(
        candidateDetails.current?.chatbot_id,
        candidateDetails.current?.id
      );
      fetchSingleApplicant(candidateDetails.current?.id);
      //  setTags(candidateDetails.current?.note_tags !== null
      //   ? candidateDetails.current?.note_tags
      //     .replace(/[^a-z,^A-Z,0-9,' ']/g, "")
      //     ?.split(/[.,!,?,;]/)
      //   : []);
      //       setComments(candidateDetails.current?.note_comment);
    }
    if (selectedIndex === 5) {
      startInterval();
    }
    if (selectedIndex === 5) {
      fetchChatbotAnswers(
        candidateDetails.current?.chatbot_id,
        candidateDetails.current?.id
      );
    }
    return () => clearInterval(intervalId);
  }, [selectedIndex, candidateDetails.current]);

  const reviewNavigator = (data, item, index) => {
    console.log(data);
    if (
      data?.subtitle === "adminI9Pdf" ||
      data?.subtitle === "converted document"
    ) {
      navigate("/review/" + profileDetails.id + "/" + index, {
        state: { data, tempId: item?.template_id },
      });
    } else {
      navigate("/review/" + profileDetails.id + "/" + index, {
        state: { tempId: item?.template_id },
      });
    }
  };

  const progressBar = (score, item) => {
    if (score == 0) {
      return "radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#DFDFDF 100%, white 0)";
    } else {
      if (item.result_type === "Pass")
        return (
          "radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#34A853 " +
          score +
          "%, white 0)"
        );
      if (
        item.result_type === "Auto-Rejected" ||
        item.result_type === "Rejected"
      )
        return (
          "radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#F93A2F " +
          score +
          "%, white 0)"
        );
      if (
        item.result_type === "Requires Further Review" ||
        item.result_type === "Incomplete"
      )
        return (
          "radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#FFB900 " +
          score +
          "%, white 0)"
        );
    }
  };

  async function handleStatusChange(status) {
    setCurrentStatus(status);
    if (status !== "default" && candidateIdList?.length !== 0) {
      const obj = {
        intervieweeids: candidateIdList,
        note_status_dropdown: status,
      };
      await ApiHelper.post(API.hireMultipleCandidates, obj)
        .then((resData) => {
          if (resData.data.success === true) {
          }
          setCandidateIdList([]);
          setCurrentStatus("default");
        })
        .catch((err) => {
          setCandidateIdList([]);
          setCurrentStatus("default");
          console.log(error);
        });
    }
  }
  function handleCheckboxChange(id) {
    let itemId = id.toString();
    if (candidateIdList.includes(itemId)) {
      setCandidateIdList((prev) => prev.filter((id) => id !== itemId));
    } else {
      setCandidateIdList((prev) => [...prev, itemId]);
    }
  }

  function selectAllApplicants() {
    if (applicants.length === candidateIdList.length) {
      setCandidateIdList([]);
    } else {
      let applicantsArr = [];
      for (let i = 0; i < applicants?.length; i++) {
        applicantsArr.push(applicants[i]?.id.toString());
      }
      setCandidateIdList(applicantsArr);
    }
  }

  async function getCandidateData(id) {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    let obj = {
      intervieweeid: id,
      userid: user?.id,
    };
    if (isMyTeamPage) {
      obj.status = "myteam";
    }
    await ApiHelper.post(API.getApplicantsbyId, obj)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          // setProfile(resData.data?.interview_data);
          candidateDetails.current = resData.data?.interview_data;
          setCompanyName(
            resData.data?.interview_data?.chatbot?.customuser?.company_name
          );
          localStorage.setItem(
            "selectedCandidate",
            resData.data?.interview_data?.first_name
          );
          localStorage.setItem(
            "candidateChatbotId",
            resData.data?.interview_data?.chatbot?.id
          );
          setProfileDetails(resData.data?.interview_data);
          setTags(
            resData.data?.interview_data?.note_tags !== null
              ? resData.data?.interview_data?.note_tags
                  .replace(/[^a-z,^A-Z,0-9,' ']/g, "")
                  ?.split(/[.,!,?,;]/)
              : []
          );
          setComments(resData.data?.interview_data?.note_comment);
          setCurrentStatus(resData.data?.interview_data?.onboarding_status);
          // fetchApplicationHistory(
          //   resData.data?.interview_data?.id,
          //   resData.data?.interview_data?.fullchatbot?.owner_id
          // );
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }

  const uploadDoc = async () => {
    console.log(doc?.target?.files[0]);
    const maxSizeInBytes = 8 * 1024 * 1024; // 8MB
    if (doc?.size > maxSizeInBytes) {
      toast("File size too large!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      if (doc !== "") {
        setLoader(true);
        console.log(doc);
        const formData = new FormData();
        formData.append("chatbotid", profileDetails.chatbot_id);
        formData.append("intervieweeid", profileDetails.id);
        formData.append("intervieweename", profileDetails.first_name);
        formData.append("document_file", doc);
        await ApiHelper.mediapost(API.uploadDoc, formData)
          .then((resData) => {
            if (resData?.data?.success === true) {
              getCandidateData(profileDetails?.id);
              setDoc("");
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
              setIsUpload(false);
            } else {
              toast(resData?.data?.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            }
            setLoader(false);
          })
          .catch((err) => {
            console.log(err);
            setLoader(false);
          });
      } else {
        toast("No document selected!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  async function downloadHandler() {
    setLoader(true);
    const obj = {
      chatbotid: profileDetails.chatbot_id, //300
      intervieweeid: profileDetails.id, //7708
    };
    await ApiHelper.post(API.getDocumentUrl, obj)
      .then((resData) => {
        if (resData.status === 200) {
          downloadFile(resData.data?.pdfURL);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }
  function downloadFile(filepath) {
    let fileName = "example.pdf";
    const link = document.createElement("a");
    link.href = filepath;
    link.setAttribute("download", fileName);
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleTextFileData = async (
    chatbotId,
    intervieweeId,
    docName,
    pdfName
  ) => {
    setLoader(true);
    const obj = {
      chatbot_id: chatbotId,
      interviewee_id: intervieweeId,
      pdf_document: docName,
    };
    const result = await ApiHelper.post(API.getConfirmedDoc, obj);
    const base64_string = result.data.base64String;
    setLoader(false);
    const dataUri = `data:application/pdf;base64,${base64_string}`;
    document.getElementById("pdfViewer").src = dataUri;
    const a = document.createElement("a");
    a.href = base64_string;
    a.download = pdfName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const getAvatar = (name) => {
    const fullName = name; // Replace with the full name you want to extract initials from

    // Split the full name into words
    const nameParts = fullName?.split(" ");

    let firstNameInitial = "";
    let lastNameInitial = "";

    // Check if there is at least one name part
    if (nameParts.length > 0) {
      // Extract the first letter of the first name
      firstNameInitial = nameParts[0].charAt(0).toUpperCase();

      // Check if there is at least one more name part (last name or middle name)
      if (nameParts.length > 1) {
        // Extract the first letter of the last name
        lastNameInitial = nameParts[nameParts.length - 1]
          .charAt(0)
          .toUpperCase();
      } else if (nameParts[0].length > 1) {
        // If there's only one name part and it has more than one letter, take the first two letters as first name initials
        firstNameInitial = nameParts[0].substring(0, 2).toUpperCase();
      }
    }

    // console.log(`First Name Initial: ${firstNameInitial}`);
    // console.log(`Last Name Initial: ${lastNameInitial}`);
    if (firstNameInitial !== "" && lastNameInitial !== "") {
      return <p>{firstNameInitial + lastNameInitial}</p>;
    } else {
      return <p>{firstNameInitial}</p>;
    }
  };

  // const isEmailValid = (email) => {
  //   // Regular expression for email validation
  //   const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  //   return emailPattern.test(email);
  // };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    // Allow only digits and the plus symbol
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (regex.test(email)) {
      setCandidateEmail(email);
      setIsEmailValid(true);
      setEmailError(false);
    } else {
      setCandidateEmail(email);
      setIsEmailValid(false);
      setEmailError(false);
    }
    // setError(false);
    // setEmailError(false);

    // if (email === "") {
    //   setError(true);
    // } else if (!isEmailValid(email)) {
    //   setError(true);
    // } else {
    //   // Perform additional validation, e.g., checking if the email already exists.
    //   // If the email is already in use, set emailError to true.
    //   // You can make an API call or use your preferred validation method here.
    // }
  };

  const editNavigateFunction = async (data) => {
    let newItemObj;
    if (data.subtitle == "converted document") {
      setLoader(true);
      const obj = {
        formfieldid: data.fields[0].id,
      };
      try {
        const result = await ApiHelper.post(
          API.applicantsGetConvertedDocument,
          obj
        );
        console.log("result", result);
        newItemObj = {
          file_buffer_encrypted_value: result.data.b64Doc,
          details: result.data.data,
          id: data.id,
          data: result.config.data,
          role: "candidate",
        };
        navigate("/dashboard/upload", { state: { item: newItemObj } });
        setLoader(false);
      } catch (err) {
        console.log("err", err);
      }
    } else {
      navigate("/dashboard/onboarding/edit-candidate-form", {
        state: { item: data },
      });
    }
  };

  const deleteDoc = async (id) => {
    setLoader(true);
    const formData = {
      documentid: id,
      type: documentType,
    };
    console.log(formData);
    await ApiHelper.post(API.deleteDoc, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchDocuments();
          setIsDeletePopupOpen(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const toggleHandler = (index, value) => {
    if (onClickIndex === value + index) {
      setOnClickToggle(false);
      setOnClickIndex(null);
    }
    if (onClickIndex !== value + index) {
      setOnClickToggle(true);
      setOnClickIndex(value + index);
    }
  };

  const historyToggleHandler = (index) => {
    console.log(index, applicationHistory[index]);
    if (onClickHistoryIndex === index) {
      setOnClickHistoryToggle(false);
      setOnClickHistoryIndex(null);
    }
    if (onClickHistoryIndex !== index) {
      setOnClickHistoryToggle(true);
      setOnClickHistoryIndex(index);
    }
  };
  const editDetails = async (field, jobId) => {
    if (field === "email") {
      const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (regex.test(reportEmail)) {
        setLoader(true);
        const formData = {
          email: reportEmail,
          chatbotid: jobId === null ? candidateJobId : jobId,
        };
        await ApiHelper.post(API.checkEmail, formData)
          .then((resData) => {
            console.log(resData);
            if (resData?.data.success === true) {
              updateDetails(reportPhone);
              setEmailError(false);
              setLoader(false);
            } else {
              toast("email already exist", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      } else {
        toast("Enter a valid email", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else if (field === "phone") {
      let num = reportPhone;
      const regex = /^[+]{1}[0-9]{11,12}$/;
      if (regex.test(reportPhone)) {
        setLoader(true);
        const formData = {
          phone: reportPhone,
          chatbotid: jobId === null ? candidateJobId : jobId,
        };
        await ApiHelper.post(API.checkPhone, formData)
          .then((resData) => {
            console.log(resData);
            if (resData?.data.success === true) {
              updateDetails(reportPhone);
              setLoader(false);
            } else {
              toast("phone number already exist", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      } else {
        if (
          reportPhone.length === 10 &&
          reportPhone.slice(0, 2) !== "+1" &&
          reportPhone.slice(0, 3) !== "+91" &&
          reportPhone.slice(0, 1) !== "+"
        ) {
          setReportPhone("+1" + num);
          setLoader(true);
          const formData = {
            phone: "+1" + num,
            chatbotid: jobId === null ? candidateJobId : jobId,
          };
          await ApiHelper.post(API.checkPhone, formData)
            .then((resData) => {
              console.log(resData);
              if (resData?.data.success === true) {
                updateDetails("+1" + num);
                setLoader(false);
              } else {
                toast("phone number already exist", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        } else {
          toast("Enter a valid phone number", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }
    } else {
      updateDetails(reportPhone);
      fetchAllCandidatesData();
    }
  };

  const updateDetails = async (phone) => {
    setLoader(true);
    const formData = {
      interviewid: profileDetails?.id,
      name: reportName,
      phone: phone,
      email: reportEmail,
    };
    await ApiHelper.post(API.editDetails, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setProfileDetails(resData.data.interview_data);
          setEditEmail(false);
          setEditName(false);
          setEditLastName(false);
          setEditPhone(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setEditEmail(false);
        setEditName(false);
        setEditLastName(false);
        setEditPhone(false);
        setLoader(false);
        console.log(err);
      });
  };

  const getDocName = (list, value) => {
    console.log(listB, listC, list, value);
    let obj = {};
    if (list === "LIST_B") {
      obj = listB?.filter((item) => item?.code === value);
    } else {
      obj = listC?.filter((item) => item?.code === value);
    }
    console.log(obj);
    if (
      obj === undefined ||
      obj[0]?.name === null ||
      obj[0]?.name === undefined
    ) {
      return "";
    } else if (obj[0]?.name === "N/A") {
      return "";
    } else return obj[0]?.name;
  };

  const resetOnboarding = async () => {
    setLoader(true);
    let id = profileDetails?.id;
    let obj = {
      intervieweeid: profileDetails?.id,
      template_id: 0,
      new_template_id: templateId !== 0 ? templateId : 0,
    };
    await ApiHelper.post(API.resetOnboarding, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setShowResetModal(false);
          setTemplateId(0);
          fetchOnboardingStatus(profileDetails?.id);
          fetchAllCandidatesData();
          getCandidateData(profileDetails?.id);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const openNewWindow = (data) => {
    // let data=data;
    localStorage.setItem("data", JSON.stringify(data));
    const newWindow = window.open("/download", "_blank");
  };

  const deleteSection = async (id) => {
    setLoader(true);
    const formData = {
      section_id: id,
    };
    await ApiHelper.post(API.deleteSectionById, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchOnboardingStatus(profileDetails?.id);
          setSectionDeleteModal(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const createZip = async (fileName, url) => {
    console.log(fileName, url);
    try {
      const response = await axios.get(url, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/zip" });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl); // Clean up
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const downloadZip = async () => {
    const zip = new JSZip();
    zip.file("hello.txt", "Hello from React!");
    zip.folder("data").file("note.txt", "Some nested data");

    const blob = await zip.generateAsync({ type: "blob" });
    saveAs(blob, "react-files.zip");
  };

  const handleDownloadZip = async () => {
    setLoader(true);
    let files = [];

    documents?.chatbotFiles.map((item) => {
      files.push(API.avenuView + item?.answer_text);
    });
    recDocs?.map((item) => {
      files.push(API.avenuView + item);
    });
    documents?.OnboardingFiles.map((item) => {
      files.push(
        API.mediaView +
          "file-library/" +
          profileDetails.chatbot_id +
          "/" +
          profileDetails.id +
          "/onboarding/" +
          item.name
      );
    });
    documents?.ConfirmedFiles.map((item) => {
      files.push(API.legalFormsView + item?.pdf_document);
    });
    console.log(files);
    const formData = {
      urls: files,
    };
    await ApiHelper.post(API.downloadZip, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.status === 200) {
          // const url = window.URL.createObjectURL(new Blob([resData.data]));
          // const link = document.createElement("a");
          // link.href = url;
          // link.setAttribute("download", profileDetails?.first_name + ".zip"); // Desired file name
          // document.body.appendChild(link);
          // link.click+();
          // link.remove();
          // downloadFile(API.baseUrl + resData?.data?.s3_path);

          const fileName = profileDetails?.first_name + ".zip";
          const filePath = API.zipDownloadView + resData?.data?.s3_path;

          // createZip(fileName, filePath);
          console.log(filePath, fileName);
          const link = document.createElement("a");
          link.href = filePath;
          link.setAttribute("download", fileName);
          // link.target = "_blank";

          // Required for Firefox
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  return (
    <div className="sidebar_open fixed-side" style={{ overflowY: "hidden" }}>
      <div className=" mt-2">
        {!isMyTeamPage ? (
          <div className="col-md-12 ">
            <div class="row d-flex align-items-center">
              <div class="team-member onbording-name-div col-md-8">
                <li className="list-group-item same-line">
                  <div className="filterAlign">
                    <div className="row">
                      {company.length !== 0 && (
                        <div className="col-sm-3 col-lg-3">
                          <div className="main-filter">
                            {/*<p className="filter-name">Company :</p>*/}
                            <select
                              class="form-select drop-filter customFilt"
                              value={filterCompany}
                              onChange={(e) => {
                                setFilterJob(0);
                                setFilterCompany(e.target.value);
                              }}
                            >
                              <option selected value={0}>
                                All Companies
                              </option>
                              {company?.map((item) => {
                                return (
                                  <option value={item.id}>
                                    {" "}
                                    {item.company_name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          {/*<p className="filter-name">Job :</p>*/}
                          <select
                            class="form-select drop-filter customFilt"
                            value={filterJob}
                            onChange={(e) => {
                              // setFilterCompany(0)
                              setFilterJob(e.target.value);
                              setCandidateJobId(e.target.value);
                            }}
                          >
                            <option selected value={0}>
                              All Chatbots
                            </option>
                            {jobs?.map((item) => {
                              return (
                                <option value={item.id}>
                                  {" "}
                                  {item.chatbot_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          {/*<p className="filter-name">Date :</p>*/}
                          <select
                            class="form-select drop-filter customFilt"
                            onChange={(e) => {
                              setFilterDate(e.target.value);
                            }}
                          >
                            <option value="">Most Recent</option>
                            <option value="lastweek">Last Week</option>
                            <option value="lastmonth">Last Month</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          {/*<p className="filter-name">Status :</p>*/}
                          <select
                            class="form-select drop-filter customFilt"
                            onChange={(e) => {
                              setFilterState(e.target.value);
                            }}
                            value={filterState}
                          >
                            <option value="hire">All</option>
                            <option value="paused">Paused</option>
                            <option value="completed">Completed</option>
                            <option value="approved">Approved</option>
                            <option value="incomplete">Incomplete</option>
                            <option value="rejected">Cancelled</option>
                            <option value="archieve">Archived</option>
                            <option value="myteam">My Team</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </div>

              <div class="search serach-width-div col-md-4">
                <div class="searchere mb-0 serach-div">
                  <img src={Serachg} alt="test" className="menu_icon search" />
                  <input
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                    value={searchText}
                    className="form-control border-0"
                    placeholder="Search...."
                  ></input>
                </div>
              </div>
            </div>

            <iframe
              id="pdfViewer"
              width="100%"
              height="600px"
              style={{ border: "1px solid #ccc", display: "none" }}
            />
          </div>
        ) : (
          <div className="col-md-12 ">
            <div class="row d-flex align-items-center">
              <div class="team-member onbording-name-div col-md-8">
                <li className="list-group-item same-line">
                  <div className="filterAlign">
                    <div className="row">
                      {company.length !== 0 && (
                        <div className="col-sm-3 col-lg-3">
                          <div className="main-filter">
                            <select
                              class="form-select drop-filter customFilt"
                              value={filterCompany}
                              onChange={(e) => {
                                setFilterJob(0);
                                setFilterCompany(e.target.value);
                              }}
                            >
                              <option selected value={0}>
                                All Companies
                              </option>
                              {company?.map((item) => {
                                return (
                                  <option value={item.id}>
                                    {" "}
                                    {item.company_name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      )}

                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          {/*<p className="filter-name">Job :</p>*/}
                          <select
                            class="form-select drop-filter customFilt"
                            value={filterJob}
                            onChange={(e) => {
                              // setFilterCompany(0)
                              setFilterJob(e.target.value);
                              // setCandidateJobId(e.target.value);
                            }}
                          >
                            <option selected value={0}>
                              All Chatbots
                            </option>
                            {jobs?.map((item) => {
                              return (
                                <option value={item.id}>
                                  {" "}
                                  {item.chatbot_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          <select
                            class="form-select drop-filter customFilt"
                            onChange={(e) => {
                              setMyteamFilter(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            <option value="Active">Active</option>
                            <option value="Terminate">Terminate</option>
                            <option value="Leave">Leave</option>
                          </select>
                        </div>
                      </div>

                      {/* <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          <select
                            class="form-select drop-filter customFilt"
                            onChange={(e) => {
                              setFilterState(e.target.value);
                            }}
                            value={filterState}
                          >
                            <option value="hire">All</option>
                            <option value="paused">Paused</option>
                            <option value="completed">Completed</option>
                            <option value="approved">Approved</option>
                            <option value="incomplete">Incomplete</option>
                            <option value="rejected">Cancelled</option>
                            <option value="archieve">Archived</option>
                            <option value="myteam">My Team</option>
                          </select>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </li>
              </div>

              <div class="search serach-width-div col-md-4">
                <div class="searchere mb-0 serach-div">
                  <img src={Serachg} alt="test" className="menu_icon search" />
                  <input
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                    value={searchText}
                    className="form-control border-0"
                    placeholder="Search...."
                  ></input>
                </div>
              </div>
            </div>

            <iframe
              id="pdfViewer"
              width="100%"
              height="600px"
              style={{ border: "1px solid #ccc", display: "none" }}
            />
          </div>
        )}

        <div className="col-md-12 mt-3">
          <div className="row">
            <div className="cand-outer col-md-4 col-lg-4">
              <div className="can-lists p-3">
                <div className="d-flex userlist m_3x">
                  <div
                    className="justify-content-between"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="hd-can pl-3">
                      <div className="form-check me-3 ms-2 ps-0">
                        <input
                          type="checkbox"
                          name="check1"
                          value="check"
                          onChange={selectAllApplicants}
                          checked={
                            applicants.length !== 0 &&
                            applicants.length === candidateIdList.length
                          }
                        />
                      </div>
                      {/*<button
                      className="addnw"
                      onClick={() => {
                        setAddCandidateOpen(true);
                      }}
                    >
                      <img src={Addnow} alt="test" className="icon" />
                    </button>*/}
                      <h4 className="allTxt">
                        {filterState === "hire"
                          ? "All"
                          : filterState === "paused"
                          ? "Paused"
                          : filterState === "completed"
                          ? "Completed"
                          : filterState === "approved"
                          ? "Approved"
                          : filterState === "incomplete"
                          ? "Incomplete"
                          : filterState === "archieve"
                          ? "Archived"
                          : filterState === "myteam"
                          ? "My Team"
                          : null}
                      </h4>
                      <div>
                        <span className="count-ca">
                          <p className="count-number">{totalCount}</p>
                        </span>
                      </div>

                      {/* <div className="add-pop">
                    <button type="button" className="btn btn-primary Add-pop mx-3"
                          onClick={() => {setAddCandidateOpen(true);}}>
                          <img src={UserChecked} alt="test" className="check-add_icon" />
                          <span>Add</span>
                    </button>
                    </div> */}
                    </div>

                    <div className="status-div">
                      {/*<div className="add-pop">
                    <button type="button" className="btn btn-primary Add-pop mx-3"
                          onClick={() => {setAddCandidateOpen(true);}}>
                          <img src={UserChecked} alt="test" className="check-add_icon" />
                          <span>Add</span>
                    </button>
                    </div>*/}

                      {candidateIdList?.length !== 0 ? (
                        <>
                          {!isMyTeamPage ? (
                            <div class="d-flex justify-content-center ">
                              <div class="form-group">
                                <select
                                  className="form-select status "
                                  value="default"
                                  style={{ width: "100px" }}
                                  onChange={(e) => {
                                    setNewStatus(e.target.value);
                                    console.log(e.target.value);
                                    if (e.target.value === "onboarding") {
                                      setMessage(
                                        "Congratulations on your new position. To start the onboarding process, please click the button below."
                                      );
                                    } else if (e.target.value === "paused") {
                                      setMessage(
                                        "Your employer has paused your onboarding process. If you have any questions, please contact. "
                                      );
                                    } else if (e.target.value === "rejected") {
                                      setMessage(
                                        "Your employer has cancelled your onboarding process. If you have any questions, please contact. "
                                      );
                                    } else if (e.target.value === "archive") {
                                      setMessage(
                                        "Are you sure you want to archive these employees? By archiving these employees, they will no longer be available on the employee list."
                                      );
                                    } else if (e.target.value === "myteam") {
                                      setMessage(
                                        "Are you sure you want to add these employees to My Team?"
                                      );
                                    } else {
                                      setMessage("");
                                    }
                                    e.target.value === "archive"
                                      ? setIsMultipleArchiveModalOpen(true)
                                      : e.target.value === "myteam"
                                      ? setIsMultipleArchiveModalOpen(true)
                                      : setIsMultipleChangeModalOpen(true);
                                  }}
                                >
                                  <option value="default">Select</option>
                                  {statusOptions.map((option) =>
                                    option?.id === 4 &&
                                    filterState === "approved" ? (
                                      <option
                                        key={option.id}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ) : option?.id !== 4 ? (
                                      <option
                                        key={option.id}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ) : null
                                  )}
                                </select>
                              </div>
                            </div>
                          ) : (
                            <div class="d-flex justify-content-center ">
                              <div class="form-group">
                                <select
                                  class="form-select status"
                                  value={
                                    profileDetails?.my_team_status === null
                                      ? "Active"
                                      : profileDetails?.my_team_status
                                  }
                                  onChange={(e) => {
                                    updateMyTeamStatus(
                                      e,
                                      profileDetails?.id,
                                      1
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  <option value="Active">Active</option>
                                  <option value="Terminate">Terminate</option>
                                  <option value="Leave">Leave</option>
                                </select>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <div class="d-flex justify-content-center ">
                          <button
                            type="button"
                            data-mdb-button-init
                            data-mdb-ripple-init
                            className="btn btn-primary Add-pop mx-3 text-right"
                            onClick={() => {
                              setAddCandidateOpen(true);
                            }}
                          >
                            <img
                              src={UserChecked}
                              alt="test"
                              className="check-add_icon"
                            />
                            <span>Add</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div id="us-scroll" className="candScroll scrlHe-tab scroll1">
                    {/* <div> */}

                    {applicants?.length !== 0 ? (
                      <ul>
                        <InfiniteScroll
                          dataLength={
                            applicants?.length === undefined
                              ? 0
                              : applicants?.length
                          }
                          // key={applicants.length}
                          next={() => {
                            usersLength === 30 &&
                              (isMyTeamPage
                                ? fetchMoreMyTeam()
                                : fetchMoreData());
                          }}
                          style={{ display: "flex", flexDirection: "column" }}
                          hasMore={usersLength === 30 ? true : false}
                          loader={
                            <div className="ca-details">
                              <span className="lastChld">Loading..</span>
                            </div>
                          }
                          endMessage={
                            <div className="ca-details">
                              <span className="lastChld">
                                Yay! You have seen it all
                              </span>
                            </div>
                          }
                          scrollableTarget="us-scroll"
                        >
                          {applicants?.map((item, index) => {
                            const roundedScore =
                              typeof item?.score === "number"
                                ? Math.ceil(item?.score * 10) / 10
                                : item?.score;
                            return (
                              <li className="user-itm">
                                <a
                                  className={
                                    profileDetails?.id === item?.id
                                      ? "candidate newDes active"
                                      : "candidate newDes"
                                  }
                                >
                                  <div className="us-lists-itm d-flex align-items-center">
                                    <div className="form-check me-3 ms-2 ps-0">
                                      <input
                                        type="checkbox"
                                        onChange={() =>
                                          handleCheckboxChange(item.id)
                                        }
                                        checked={candidateIdList.includes(
                                          String(item.id)
                                        )}
                                        name="check1"
                                        value="check"
                                      />
                                    </div>
                                    <div
                                      className="d-flex wrp align-items-center"
                                      onClick={() => {
                                        getCandidateData(item?.id);
                                        setCaseId(item?.e_verify_casId);
                                        setIndex(index);
                                        setRsTab(true);
                                        setOnClickToggle(false);
                                        setOnClickIndex(null);
                                        // fetchChatbotAnswers(
                                        //   item?.chatbot_id,
                                        //   item?.id
                                        // );
                                        setEditEmail(false);
                                        setEditName(false);
                                        setEditPhone(false);
                                        // item?.is_my_team === 1 &&
                                        //   setSelectedIndex(2);
                                      }}
                                    >
                                      <div
                                        className="avatar"
                                        style={{ backgroundColor: "#41D1FF" }}
                                      >
                                        {getAvatar(item?.first_name)}
                                      </div>
                                      <div className="profie-width">
                                        <div className="ca-details">
                                          <h3>
                                            {item?.last_name !== null
                                              ? item?.first_name +
                                                " " +
                                                item?.last_name
                                              : item?.first_name}
                                          </h3>
                                          <span>
                                            {item?.chatbot?.chatbot_name}
                                          </span>
                                        </div>
                                        {messageCount?.map((data) => {
                                          return (
                                            item?.id ===
                                              data?.interviewee_id && (
                                              <span className="count-t-details ms-3">
                                                {data?.unread_count}
                                              </span>
                                            )
                                          );
                                        })}
                                        {item?.view_status === 1 && (
                                          <span className="new-spans ml-2">
                                            <p className="new-letter">NEW</p>
                                          </span>
                                        )}

                                        {item?.section_status ===
                                          "Action Required" && (
                                          <img
                                            src={RedAlert}
                                            alt="test"
                                            style={{
                                              width: "2vh",
                                              height: "2vh",
                                            }}
                                            className="mx-2"
                                          />
                                        )}
                                        {/* <div className='progress-bar' min="0" max="100" style={{ background: progressBar(item?.score.toFixed(), item) }}>{item?.score.toFixed()}</div> */}
                                        {isMyTeamPage ? (
                                          <div
                                            className={
                                              item?.my_team_status ===
                                                "Active" ||
                                              item?.my_team_status === null
                                                ? "text-success  team-algmt pr-2 "
                                                : item?.my_team_status ===
                                                  "Leave"
                                                ? "text-primary team-algmt pr-2 "
                                                : item?.my_team_status ===
                                                  "Terminate"
                                                ? "text-danger team-algmt pr-2 "
                                                : null
                                            }
                                          >
                                            {item?.my_team_status === null
                                              ? "Active"
                                              : item?.my_team_status}
                                          </div>
                                        ) : (
                                          <div
                                            className={
                                              filterState === "approved"
                                                ? "text-primary"
                                                : item?.onboarding_completed_percentage <
                                                  35
                                                ? "text-danger "
                                                : item?.onboarding_completed_percentage <
                                                  60
                                                ? "text-warning "
                                                : "text-success "
                                            }
                                          >
                                            {
                                              item?.onboarding_completed_percentage
                                            }
                                            %
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </li>
                            );
                          })}
                        </InfiniteScroll>
                      </ul>
                    ) : (
                      <h4 className="mx-2 my-4 lastChld">
                        Candidate Not Found
                      </h4>
                    )}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>

            {applicants.length !== 0 && profileDetails?.id !== undefined && (
              <div
                className={
                  rsTab === true
                    ? "col-md-8 col-lg-8 candPads active"
                    : "col-md-8 col-lg-8 candPads"
                }
              >
                <div className="d-flex detail-user blueBorder p-0">
                  <div className="alignTops mb-0 p-3">
                    <div className="llbw m-0">
                      <div className="candidate">
                        <div className="d-flex wrp align-items-center">
                          <div
                            className="avatar"
                            style={{
                              backgroundColor: "#41D1FF",
                            }}
                          >
                            <span>{getAvatar(profileDetails?.first_name)}</span>
                          </div>
                          <div className="ca-details">
                            <h3>
                              {profileDetails?.last_name !== null
                                ? profileDetails?.first_name +
                                  " " +
                                  profileDetails?.last_name
                                : profileDetails.first_name}
                            </h3>
                            {/*<span className="styDiv">{profileDetails.email}</span>*/}
                            <a
                              className="call-text styDiv"
                              href={`tel:${profileDetails?.phone}`}
                            >
                              {profileDetails?.phone
                                ?.replace(/\s+/g, "")
                                ?.slice(-10)
                                ?.replace(
                                  /^(\d{3})(\d{3})(\d{4})$/,
                                  "$1-$2-$3"
                                )}
                            </a>
                          </div>
                        </div>
                        {/* <div className='progress-bar detail' value="100" min="0" max="100" style={{ background: progressBar(typeof profileDetails.score === 'number' ? (Math.ceil(profileDetails.score * 10) / 10) : profileDetails.score, profileDetails) }}>{profileDetails?.score?.toFixed()} */}
                        {isMyTeamPage ? null : (
                          <div
                            className={
                              profileDetails?.onboarding_completed_percentage <
                              35
                                ? "text-danger per-align ml-3"
                                : profileDetails?.onboarding_completed_percentage <
                                  60
                                ? "text-warning ml-3 per-align"
                                : "text-success ml-3 per-align"
                            }
                          >
                            {profileDetails?.onboarding_completed_percentage}%
                          </div>
                        )}
                        {/* </div> */}
                      </div>
                    </div>

                    {isMyTeamPage ? (
                      <div className="col-sm-3 col-lg-3">
                        <div className="main-filter">
                          <select
                            class="form-select drop-filter customFilt"
                            value={
                              profileDetails?.my_team_status === null
                                ? "Active"
                                : profileDetails?.my_team_status
                            }
                            onChange={(e) => {
                              updateMyTeamStatus(e, profileDetails?.id, 0);
                            }}
                          >
                            <option value="">Select</option>
                            <option value="Active">Active</option>
                            <option value="Terminate">Terminate</option>
                            <option value="Leave">Leave</option>
                          </select>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center m-0">
                        <h4></h4>
                        <button className="menu-btn back">
                          <img src={Menu} alt="test" className="menu_icon" />
                        </button>
                        {currentStatus === null ? (
                          <button
                            class="dropbtn btnArw send-on-bttn"
                            onClick={() => {
                              checkStatus("onboarding");
                            }}
                          >
                            <img
                              src={onboardingimage}
                              className="drop-imaege"
                            />
                            Send Onboarding
                          </button>
                        ) : (
                          <div class="dropdown">
                            <button class="dropbtn btnArw">
                              <img
                                src={
                                  currentStatus === "onboarding" ||
                                  currentStatus === "resendonboarding"
                                    ? onboardingimage
                                    : currentStatus === "rejected"
                                    ? rejectimage
                                    : currentStatus === "paused"
                                    ? pauseimage
                                    : currentStatus === "resumed"
                                    ? resumeimage
                                    : currentStatus === "archive"
                                    ? Archive
                                    : null
                                }
                                alt="test"
                                className="drop-imaege"
                              />
                              {currentStatus === "onboarding" ||
                              currentStatus === "resendonboarding"
                                ? "Onboarding"
                                : currentStatus === "rejected"
                                ? "Cancelled"
                                : currentStatus === "paused"
                                ? "Paused"
                                : currentStatus === "resumed"
                                ? "Resumed"
                                : currentStatus === "archive"
                                ? "Archived"
                                : null}{" "}
                            </button>

                            {currentStatus !== "archive" ? (
                              <div class="dropText">
                                <a
                                  // className={
                                  //   (currentStatus === "onboarding" || currentStatus === "resumed") && "disableditem"}
                                  onClick={() => {
                                    currentStatus === "paused" ||
                                    currentStatus === "rejected"
                                      ? checkStatus("resumed")
                                      : currentStatus === "onboarding" ||
                                        currentStatus === "resumed" ||
                                        currentStatus === "resendonboarding"
                                      ? checkStatus("resendonboarding")
                                      : checkStatus("onboarding");
                                  }}
                                >
                                  {currentStatus === "paused" ||
                                  currentStatus === "rejected"
                                    ? "Resume"
                                    : currentStatus === "onboarding" ||
                                      currentStatus === "resumed" ||
                                      currentStatus === "resendonboarding"
                                    ? "Resend Onboarding"
                                    : "Onboarding"}
                                </a>
                                <a
                                  className={
                                    currentStatus !== "onboarding" &&
                                    currentStatus !== "resumed" &&
                                    currentStatus !== "resendonboarding" &&
                                    "disableditem-my"
                                  }
                                  onClick={() => {
                                    (currentStatus === "onboarding" ||
                                      currentStatus === "resumed" ||
                                      currentStatus === "resendonboarding") &&
                                      checkStatus("paused");
                                  }}
                                >
                                  Pause
                                </a>
                                <a
                                  onClick={() => {
                                    setNewStatus("archive");
                                    setMessage(
                                      "Are you sure you want to archive this employee? By archiving this employee, they will no longer be available on the employee list."
                                    );
                                    setArchiveModal(true);
                                  }}
                                >
                                  Archive
                                </a>
                                {!isMyTeamPage && (
                                  <a
                                    className={!isMyteam && "disableditem-my"}
                                    onClick={() => {
                                      if (isMyteam) {
                                        setNewStatus("myteam");
                                        setMessage(
                                          "Are you sure you want to add this employee to My Team?"
                                        );
                                        setArchiveModal(true);
                                      }
                                    }}
                                  >
                                    My Team
                                  </a>
                                )}
                                <a
                                  className={
                                    currentStatus === "rejected" &&
                                    "disableditem"
                                  }
                                  onClick={() => {
                                    currentStatus !== "rejected" &&
                                      checkStatus("rejected");
                                  }}
                                >
                                  {" "}
                                  Cancel
                                </a>
                                <a
                                  className={
                                    currentStatus !== "onboarding" &&
                                    currentStatus !== "resumed" &&
                                    currentStatus !== "resendonboarding" &&
                                    "disableditem-my"
                                  }
                                  onClick={() => {
                                    (currentStatus === "onboarding" ||
                                      currentStatus === "resumed" ||
                                      currentStatus === "resendonboarding") &&
                                      setShowResetModal(true);
                                  }}
                                >
                                  {isMyTeamPage
                                    ? "Restart"
                                    : "Restart Onboarding"}
                                </a>
                              </div>
                            ) : (
                              <div class="dropText">
                                <a
                                  // className={
                                  //   (currentStatus === "onboarding" || currentStatus === "resumed") && "disableditem"}
                                  onClick={() => {
                                    setNewStatus("unarchive");
                                    setMessage(
                                      "Are you sure you want to unarchive this employee? By unarchiving this employee, they will be available on the employee list."
                                    );

                                    setArchiveModal(true);
                                  }}
                                >
                                  Unarchive
                                </a>
                              </div>
                            )}
                          </div>
                        )}

                        {/* <button className='dwn' >Download PDF <img src={Download} alt="test" className="download-pdf" /> </button> */}

                        {/*<Form.Select value={currentStatus ? currentStatus : 'defalut'} aria-label="Default select example" className="drop-select" onChange={(e) => checkStatus(e.target.value)}>
                                          <option value='default'><img src={pauseimage} alt="test" className="menu_icon " />Status</option>
                                              <option value='default'> <span className="dot"><p className="number-dot"></p></span> Select Status</option>
                                              {
                                                  statusOptions.map((option) => (
                                                      <option key={option.id} value={option.value}>{option.label}</option>
                                                  ))
                                              }
                                          </Form.Select>*/}
                      </div>
                    )}
                  </div>
                  {/* <div className='detail-btns'>
                                        <div className='d-flex inv-det'>
                                            <div class="col-md-3">
                                                <button className={status === 'hire' ? 'invite w33 flex-fill active' : 'invite w33 flex-fill'} onClick={() => { updateStatus('hire') }}>Hire</button>
                                            </div>
                                            <div class="col-md-3">
                                                <button className={status === 'under_review' ? 'invite w33 flex-fill active' : 'invite w33 flex-fill'} onClick={() => { updateStatus('Needs Review') }} >Needs Review</button>
                                            </div>
                                            <div class="col-md-3">
                                                <button className={status === 'reject' ? 'invite w33 flex-fill active' : 'invite w33 flex-fill'} onClick={() => { updateStatus('Reject') }} >Reject</button>
                                            </div>
                                            <div class="col-md-3">
                                                <button className={status === 'Invite to Interview' ? 'invite w-100 flex-fill active' : 'invite w-100 flex-fill'} onClick={() => { updateStatus('Invite to Interview') }} >Invite to Interview</button>
                                            </div>
                                        </div>
                                    </div> */}
                  <div className="detail-tabs">
                    <Tabs
                      selectedIndex={selectedIndex}
                      onSelect={handleTabClick}
                    >
                      <TabList>
                        <Tab
                          style={{
                            margin: "0px 10px 0px 18px",
                          }}
                        >
                          {isMyTeamPage ? "Employee Docs" : "Onboarding Status"}
                        </Tab>
                        {/*<Tab>{caseId!==null && 'E-verify Page'}</Tab>*/}
                        <Tab
                          style={{
                            margin:
                              !isMyTeamPage && caseId !== null
                                ? "0px 10px 0px 18px"
                                : null,
                          }}
                        >
                          {!isMyTeamPage && caseId !== null ? (
                            <img
                              src={caselogo}
                              alt="test"
                              className="all-caselogo"
                            />
                          ) : null}
                        </Tab>
                        <Tab style={{ margin: "0px 10px 0px 18px" }}>
                          {" "}
                          {isMyTeamPage
                            ? "Applications"
                            : "Application History"}
                        </Tab>

                        <Tab style={{ margin: "0px 10px 0px 18px" }}>PDFs</Tab>
                        <Tab style={{ margin: "0px 10px 0px 18px" }}>
                          {isMyTeamPage ? "Employee Details" : "Details"}
                        </Tab>
                        <Tab style={{ margin: "0px 10px 0px 18px" }}>
                          SMS
                          {messageCount?.map((item) => {
                            return (
                              item?.interviewee_id === profileDetails?.id && (
                                <span className="count-t-mesg  ms-3">
                                  {item?.unread_count}
                                </span>
                              )
                            );
                          })}
                        </Tab>
                        {/* <Tab>Conversations</Tab> */}
                      </TabList>
                      <div className="under-line"></div>
                      <div className="pl-3 pt-3 pb-3">
                        <TabPanel>
                          <div className="iner-sc scrlHe-tab pr-3">
                            {/* <p className='expire-text'>Expires in 3 days</p> */}

                            <div className="my-0 mx-0 mb-0 topAlg">
                              <div className="row">
                                <div className="col-md-9 docBrad">
                                  {/* <Breadcrumb>
                                                    <Breadcrumb.Item href="#">
                                                      Business Documents
                                                    </Breadcrumb.Item>
                                                    <Breadcrumb.Item active>
                                                      Weekly Reports
                                                    </Breadcrumb.Item>
                                                  </Breadcrumb> */}
                                </div>
                                {isMyTeamPage && (
                                  <div className="col-md-3">
                                    <img
                                      src={documentimage}
                                      alt="test"
                                      className="document-image"
                                      onClick={() => {
                                        setIsSendForms(true);
                                        setSendFormMessage(
                                          "Hi " +
                                            profileDetails?.first_name +
                                            ", Fill the forms from the below link before the deadline."
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                              <hr />
                            </div>
                            {profileDetails?.onboarding_status === null ? (
                              <h4 className="mx-3 no-msg">
                                The onboarding document has not been sent
                              </h4>
                            ) : (
                              onBorardingStatus?.length !== 0 && (
                                <div className="tableFixHead first-tble-mytem">
                                  <div className="myteam-first-one">
                                    <table class="table">
                                      <thead className="table-text">
                                        <tr className="">
                                          <th
                                            className="firstTab onboard-widthz"
                                            scope="col"
                                          >
                                            {isMyTeamPage
                                              ? "Onboarding Docs"
                                              : "Section"}
                                          </th>

                                          <th scope="col" className="">
                                            Status
                                          </th>

                                          <th
                                            className="dateTab text-ends"
                                            scope="col"
                                          >
                                            Date
                                          </th>

                                          <th className="lastTab" scope="col">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="table-text-body on-docs-dive">
                                        {onBorardingStatus.map(
                                          (item, index) => (
                                            <>
                                              {console.log(index)}
                                              {item?.forms?.length !== 0 && (
                                                <tr style={{ border: "#fff" }}>
                                                  <td
                                                    className="firstTab arrow-btwn myteam-algment"
                                                    onClick={() => {
                                                      toggleHandler(
                                                        index,
                                                        "docs"
                                                      );
                                                    }}
                                                  >
                                                    {item.section_name}
                                                    {onClickToggle === true &&
                                                    onClickIndex ===
                                                      "docs" + index ? (
                                                      <img
                                                        src={downarrows}
                                                        alt="test"
                                                        className="arrowrr-img arrowrr-rotate"
                                                      />
                                                    ) : (
                                                      <img
                                                        src={downarrows}
                                                        alt="test"
                                                        className="arrowrr-img"
                                                      />
                                                    )}
                                                  </td>
                                                  <td
                                                    className="text-end-onbo"
                                                    onClick={() => {
                                                      toggleHandler(
                                                        index,
                                                        "docs"
                                                      );
                                                    }}
                                                  >
                                                    <div className="d-flex align-items-center">
                                                      {" "}
                                                      <div
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title={
                                                          item.section_status ===
                                                          "Success"
                                                            ? "Employer aprroval pending"
                                                            : null
                                                        }
                                                      >
                                                        <img
                                                          src={
                                                            item.section_status ===
                                                            "Pending"
                                                              ? Alerts
                                                              : item.section_status ===
                                                                "Not Send"
                                                              ? NotSend
                                                              : item.section_status ===
                                                                "Success"
                                                              ? Successful
                                                              : item.section_status ===
                                                                "Action Required"
                                                              ? RedAlert
                                                              : Approved
                                                          }
                                                          alt="test"
                                                          className="files me-2"
                                                        />

                                                        {item.section_status ===
                                                        "Pending"
                                                          ? "Employee in Progress"
                                                          : item.section_status ===
                                                            "Not Send"
                                                          ? "Not Send"
                                                          : item.section_status ===
                                                            "Success"
                                                          ? "Completed"
                                                          : item.section_status ===
                                                            "Action Required"
                                                          ? "Employer Action"
                                                          : "Approved"}
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td
                                                    className="dateTab text-ends"
                                                    onClick={() => {
                                                      toggleHandler(
                                                        index,
                                                        "docs"
                                                      );
                                                    }}
                                                  >
                                                    {moment(
                                                      item.created_at
                                                    ).format("MMMM D, YYYY")}
                                                  </td>

                                                  <td className="lastTab d-flex">
                                                    {currentStatus !== null && (
                                                      <a
                                                        className="review-blue"
                                                        onClick={() => {
                                                          navigate(
                                                            "/review/" +
                                                              profileDetails.id +
                                                              "/" +
                                                              index,
                                                            {
                                                              state: {
                                                                tempId:
                                                                  item?.template_id,
                                                              },
                                                            }
                                                          );
                                                        }}
                                                      >
                                                        View Document
                                                      </a>
                                                    )}
                                                    <button
                                                      className="head-close border-0 ms-4 clsBt"
                                                      onClick={() => {
                                                        setModalData({
                                                          itemId: item?.id,
                                                          itemName:
                                                            item?.section_name,
                                                        });
                                                        setSectionDeleteModal(
                                                          true
                                                        );
                                                      }}
                                                    >
                                                      <img
                                                        src={trash}
                                                        alt="test"
                                                        className="menu_icon"
                                                      />
                                                    </button>
                                                  </td>
                                                </tr>
                                              )}

                                              {onClickToggle === true &&
                                              onClickIndex ===
                                                "docs" + index ? (
                                                <>
                                                  <tr>
                                                    <td className="firstTab paddleft-sub-heading ml-2 sub-fonts-stylez">
                                                      Forms
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                  </tr>

                                                  {item?.section_forms?.map(
                                                    (data) => {
                                                      return (
                                                        <tr className="">
                                                          <td
                                                            className="firstTab paddleft-sub-heading ml-2"
                                                            style={{
                                                              border: "#fff",
                                                            }}
                                                          >
                                                            {data?.title}
                                                          </td>
                                                          <td
                                                            className="text-end"
                                                            style={{
                                                              border: "#fff",
                                                            }}
                                                          >
                                                            <div className="d-flex align-items-center ml-2">
                                                              {" "}
                                                              <img
                                                                src={
                                                                  item.section_status ===
                                                                  "Not Send"
                                                                    ? NotSend
                                                                    : data.completed_status ===
                                                                      0
                                                                    ? Alerts
                                                                    : data.completed_status ===
                                                                        1 &&
                                                                      (data
                                                                        ?.fields[0]
                                                                        ?.field_type_id ===
                                                                        13 ||
                                                                        data?.template_type ===
                                                                          "i-9form" ||
                                                                        data?.template_type ===
                                                                          "w4-form" ||
                                                                        data?.template_type ===
                                                                          "W4Sc-form" ||
                                                                        data?.template_type ===
                                                                          "MI-W4_Form" ||
                                                                        data?.template_type ===
                                                                          "L4-pdf") &&
                                                                      data?.employer_status ===
                                                                        0
                                                                    ? RedAlert
                                                                    : Successful
                                                                }
                                                                alt="test"
                                                                className="files me-2"
                                                              />
                                                              {item.section_status ===
                                                              "Not Send"
                                                                ? "Not Send"
                                                                : data.completed_status ===
                                                                  0
                                                                ? "Employee in Progress"
                                                                : data.completed_status ===
                                                                    1 &&
                                                                  (data
                                                                    ?.fields[0]
                                                                    ?.field_type_id ===
                                                                    13 ||
                                                                    data?.template_type ===
                                                                      "i-9form" ||
                                                                    data?.template_type ===
                                                                      "w4-form" ||
                                                                    data?.template_type ===
                                                                      "W4Sc-form" ||
                                                                    data?.template_type ===
                                                                      "MI-W4_Form" ||
                                                                    data?.template_type ===
                                                                      "L4-pdf") &&
                                                                  data?.employer_status ===
                                                                    0
                                                                ? "Employer Action"
                                                                : "Completed"}
                                                            </div>
                                                          </td>
                                                          <td
                                                            className="dateTab text-ends"
                                                            style={{
                                                              border: "#fff",
                                                            }}
                                                          >
                                                            {moment(
                                                              data.created_at
                                                            ).format(
                                                              "MMMM D, YYYY"
                                                            )}
                                                          </td>

                                                          {data.title ===
                                                            "i-9.pdf" ||
                                                          data.title ===
                                                            "w4.pdf" ? (
                                                            <td
                                                              className="lastTab"
                                                              style={{
                                                                border: "#fff",
                                                              }}
                                                            >
                                                              {/* Add your Review tab content here */}
                                                              <a
                                                                className="review-blue"
                                                                onClick={() => {
                                                                  reviewNavigator(
                                                                    data,
                                                                    item,
                                                                    index
                                                                  );
                                                                }}
                                                              >
                                                                View Document
                                                              </a>
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="lastTab"
                                                              style={{
                                                                border: "#fff",
                                                              }}
                                                            >
                                                              {currentStatus ===
                                                                null &&
                                                                (data?.template_type !==
                                                                  "i-9form" &&
                                                                data?.template_type !==
                                                                  "w4-form" &&
                                                                data?.template_type !==
                                                                  "W4Sc-form" ? (
                                                                  <a
                                                                    className="review-blue"
                                                                    onClick={() => {
                                                                      //  data?.fields[0]?.field_type_id===13?navigate("/dashboard/upload"): navigate("/dashboard/onboarding/edit-candidate-form", { state: { item: data } })
                                                                      editNavigateFunction(
                                                                        data
                                                                      );
                                                                    }}
                                                                  >
                                                                    Edit
                                                                  </a>
                                                                ) : null)}
                                                              {console.log(
                                                                "item item item",
                                                                item
                                                              )}
                                                              {currentStatus !==
                                                                null && (
                                                                <div className="d-flex">
                                                                  <a
                                                                    className="review-blue case-blue"
                                                                    onClick={() => {
                                                                      //  data?.fields[0]?.field_type_id===13?navigate("/dashboard/upload"): navigate("/dashboard/onboarding/edit-candidate-form", { state: { item: data } })
                                                                      reviewNavigator(
                                                                        data,
                                                                        item,
                                                                        index
                                                                      );
                                                                    }}
                                                                  >
                                                                    View
                                                                  </a>
                                                                  {data.completed_status ===
                                                                    1 &&
                                                                  data
                                                                    ?.fields[0]
                                                                    ?.field_type_id !==
                                                                    13 &&
                                                                  data?.template_type !==
                                                                    "i-9form" &&
                                                                  data?.template_type !==
                                                                    "w4-form" &&
                                                                  data?.template_type !==
                                                                    "W4Sc-form" &&
                                                                  data?.template_type !==
                                                                    "Ohio-it4-combined" &&
                                                                  data?.template_type !==
                                                                    "MI-W4_Form" &&
                                                                  data?.template_type !==
                                                                    "L4-pdf" &&
                                                                  data?.template_type !==
                                                                    "AR4EC-pdf" ? (
                                                                    <button
                                                                      className="  download-icon case-left-down-icon2 visible-dw-btn"
                                                                      onClick={() => {
                                                                        openNewWindow(
                                                                          data
                                                                        );
                                                                      }}
                                                                    >
                                                                      <img
                                                                        src={
                                                                          Download
                                                                        }
                                                                        alt="test"
                                                                        className="files "
                                                                      />
                                                                    </button>
                                                                  ) : null}
                                                                  {data.employer_status ===
                                                                    1 &&
                                                                    data
                                                                      ?.fields[0]
                                                                      ?.field_type_id ===
                                                                      13 &&
                                                                    (data?.DownloadconvertedDoc !==
                                                                      "" ||
                                                                      data?.DownloadconvertedDoc !==
                                                                        null) && (
                                                                      <button
                                                                        className="download-icon case-left-down-icon2 visible-dw-btn"
                                                                        onClick={() => {
                                                                          handleTextFileData(
                                                                            profileDetails
                                                                              ?.chatbot
                                                                              ?.id,
                                                                            item?.interviewee_id,
                                                                            data?.DownloadconvertedDoc,
                                                                            data?.pdf_name
                                                                          );
                                                                        }}
                                                                      >
                                                                        <img
                                                                          src={
                                                                            Download
                                                                          }
                                                                          alt="test"
                                                                          className="files files "
                                                                        />
                                                                      </button>
                                                                    )}
                                                                  {data.employer_status ===
                                                                    1 &&
                                                                  (data?.template_type ===
                                                                    "i-9form" ||
                                                                    data?.template_type ==
                                                                      "w4-form" ||
                                                                    data?.template_type ===
                                                                      "W4Sc-form" ||
                                                                    data?.template_type ===
                                                                      "Ohio-it4-combined" ||
                                                                    data?.template_type ===
                                                                      "MI-W4_Form" ||
                                                                    data?.template_type ===
                                                                      "L4-pdf" ||
                                                                    data?.template_type ==
                                                                      "AR4EC-pdf") &&
                                                                  data?.Downloadleagalform !==
                                                                    "" &&
                                                                  data?.Downloadleagalform !==
                                                                    null ? (
                                                                    <button
                                                                      className="download-icon case-left-down-icon2 visible-dw-btn"
                                                                      onClick={() => {
                                                                        downloadFile(
                                                                          API.legalFormsView +
                                                                            data?.Downloadleagalform
                                                                        );
                                                                      }}
                                                                    >
                                                                      {" "}
                                                                      <img
                                                                        src={
                                                                          Download
                                                                        }
                                                                        alt="test"
                                                                        className="files"
                                                                      />
                                                                    </button>
                                                                  ) : null}
                                                                  {data?.template_type ===
                                                                    "i-9form" &&
                                                                    data?.case_status !==
                                                                      null && (
                                                                      <div className="text-danger in-com tooltip caselogo-div">
                                                                        <img
                                                                          src={
                                                                            caselogo
                                                                          }
                                                                          alt="test"
                                                                          className="caselogo  "
                                                                        />
                                                                        <img
                                                                          src={
                                                                            caseimg
                                                                          }
                                                                          alt="test"
                                                                          className="caselogo "
                                                                        />
                                                                        <span class="tooltiptext">
                                                                          {
                                                                            data?.case_status_display
                                                                          }{" "}
                                                                        </span>
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              )}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                                </>
                                              ) : null}
                                            </>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  {!isMyTeamPage && (
                                    <div class="col-sm-12 mt-4">
                                      {isApproveShow &&
                                        profileDetails?.onboarding_status !==
                                          null && (
                                          <button
                                            type="button"
                                            className={
                                              isApprove
                                                ? "update-btn rounded p-2 appro-btton"
                                                : "update-btn rounded p-2 appro-btton-gray"
                                            }
                                            onClick={() => {
                                              isApprove && setIsOpen(true);
                                              setTempId(tempId);
                                            }}
                                          >
                                            Approve
                                          </button>
                                        )}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                            {otherForms?.length !== 0 && (
                              <div className="tableFixHead">
                                <table class="table">
                                  <thead className="table-text">
                                    <tr>
                                      <th className="firstTab onboard-widthz mt-2 mb-2">
                                        Other Forms
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody className="table-text-body">
                                    {[...groupMap.entries()].map(
                                      ([tempId, items]) => {
                                        const showButton = items.some(
                                          (item) =>
                                            item.section_status !== "Confirmed"
                                        );
                                        return (
                                          <div>
                                            {items?.map((item, index) => (
                                              <>
                                                {console.log(index)}
                                                {item?.forms?.length !== 0 && (
                                                  <tr
                                                    style={{ border: "#fff" }}
                                                  >
                                                    <td
                                                      className="firstTab arrow-btwn mytem-withs "
                                                      onClick={() => {
                                                        toggleHandler(
                                                          index,
                                                          "form"
                                                        );
                                                      }}
                                                    >
                                                      {item.section_name}
                                                      {onClickToggle === true &&
                                                      onClickIndex ===
                                                        "form" + index ? (
                                                        <img
                                                          src={downarrows}
                                                          alt="test"
                                                          className="arrowrr-img arrowrr-rotate"
                                                        />
                                                      ) : (
                                                        <img
                                                          src={downarrows}
                                                          alt="test"
                                                          className="arrowrr-img"
                                                        />
                                                      )}
                                                    </td>
                                                    <td
                                                      className="text-end my-tems-staus"
                                                      onClick={() => {
                                                        toggleHandler(
                                                          index,
                                                          "form"
                                                        );
                                                      }}
                                                    >
                                                      <div className="d-flex align-items-center">
                                                        {" "}
                                                        <div
                                                          data-toggle="tooltip"
                                                          data-placement="top"
                                                          title={
                                                            item.section_status ===
                                                            "Success"
                                                              ? "Employer aprroval pending"
                                                              : null
                                                          }
                                                        >
                                                          <img
                                                            src={
                                                              item.section_status ===
                                                              "Pending"
                                                                ? Alerts
                                                                : item.section_status ===
                                                                  "Not Send"
                                                                ? NotSend
                                                                : item.section_status ===
                                                                  "Success"
                                                                ? Successful
                                                                : item.section_status ===
                                                                  "Action Required"
                                                                ? RedAlert
                                                                : Approved
                                                            }
                                                            alt="test"
                                                            className="files me-2"
                                                          />

                                                          {item.section_status ===
                                                          "Pending"
                                                            ? "Employee in Progress"
                                                            : item.section_status ===
                                                              "Not Send"
                                                            ? "Not Send"
                                                            : item.section_status ===
                                                              "Success"
                                                            ? "Completed"
                                                            : item.section_status ===
                                                              "Action Required"
                                                            ? "Employer Action"
                                                            : "Approved"}
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td
                                                      className="dateTab text-ends"
                                                      onClick={() => {
                                                        toggleHandler(
                                                          index,
                                                          "form"
                                                        );
                                                      }}
                                                    >
                                                      {moment(
                                                        item.created_at
                                                      ).format("MMMM D, YYYY")}
                                                    </td>

                                                    <td className="lastTab">
                                                      {currentStatus !==
                                                        null && (
                                                        <a
                                                          className="review-blue"
                                                          onClick={() => {
                                                            navigate(
                                                              "/review/" +
                                                                profileDetails.id +
                                                                "/" +
                                                                index,
                                                              {
                                                                state: {
                                                                  tempId:
                                                                    item?.template_id,
                                                                },
                                                              }
                                                            );
                                                          }}
                                                        >
                                                          View Document
                                                        </a>
                                                      )}
                                                      <button
                                                        className="head-close border-0 ms-4 clsBt"
                                                        onClick={() => {
                                                          setModalData({
                                                            itemId: item?.id,
                                                            itemName:
                                                              item?.section_name,
                                                          });
                                                          setSectionDeleteModal(
                                                            true
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src={trash}
                                                          alt="test"
                                                          className="menu_icon"
                                                        />
                                                      </button>
                                                    </td>
                                                  </tr>
                                                )}

                                                {onClickToggle === true &&
                                                onClickIndex ===
                                                  "form" + index ? (
                                                  <>
                                                    <tr>
                                                      <td className="firstTab paddleft-sub-heading ml-2 sub-fonts-stylez">
                                                        Forms
                                                      </td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                    </tr>

                                                    {item?.section_forms?.map(
                                                      (data) => {
                                                        return (
                                                          <tr className="">
                                                            <td
                                                              className="firstTab paddleft-sub-heading ml-2"
                                                              style={{
                                                                border: "#fff",
                                                              }}
                                                            >
                                                              {data?.title}
                                                            </td>
                                                            <td
                                                              className="text-end"
                                                              style={{
                                                                border: "#fff",
                                                              }}
                                                            >
                                                              <div className="d-flex align-items-center ml-2">
                                                                {" "}
                                                                <img
                                                                  src={
                                                                    item.section_status ===
                                                                    "Not Send"
                                                                      ? NotSend
                                                                      : data.completed_status ===
                                                                        0
                                                                      ? Alerts
                                                                      : data.completed_status ===
                                                                          1 &&
                                                                        (data
                                                                          ?.fields[0]
                                                                          ?.field_type_id ===
                                                                          13 ||
                                                                          data?.template_type ===
                                                                            "i-9form" ||
                                                                          data?.template_type ===
                                                                            "w4-form" ||
                                                                          data?.template_type ===
                                                                            "W4Sc-form" ||
                                                                          data?.template_type ===
                                                                            "MI-W4_Form" ||
                                                                          data?.template_type ===
                                                                            "L4-pdf") &&
                                                                        data?.employer_status ===
                                                                          0
                                                                      ? RedAlert
                                                                      : Successful
                                                                  }
                                                                  alt="test"
                                                                  className="files me-2"
                                                                />
                                                                {item.section_status ===
                                                                "Not Send"
                                                                  ? "Not Send"
                                                                  : data.completed_status ===
                                                                    0
                                                                  ? "Employee in Progress"
                                                                  : data.completed_status ===
                                                                      1 &&
                                                                    (data
                                                                      ?.fields[0]
                                                                      ?.field_type_id ===
                                                                      13 ||
                                                                      data?.template_type ===
                                                                        "i-9form" ||
                                                                      data?.template_type ===
                                                                        "w4-form" ||
                                                                      data?.template_type ===
                                                                        "W4Sc-form" ||
                                                                      data?.template_type ===
                                                                        "MI-W4_Form" ||
                                                                      data?.template_type ===
                                                                        "L4-pdf") &&
                                                                    data?.employer_status ===
                                                                      0
                                                                  ? "Employer Action"
                                                                  : "Completed"}
                                                              </div>
                                                            </td>
                                                            <td
                                                              className="dateTab text-ends"
                                                              style={{
                                                                border: "#fff",
                                                              }}
                                                            >
                                                              {moment(
                                                                data.created_at
                                                              ).format(
                                                                "MMMM D, YYYY"
                                                              )}
                                                            </td>

                                                            {data.title ===
                                                              "i-9.pdf" ||
                                                            data.title ===
                                                              "w4.pdf" ? (
                                                              <td
                                                                className="lastTab"
                                                                style={{
                                                                  border:
                                                                    "#fff",
                                                                }}
                                                              >
                                                                {/* Add your Review tab content here */}
                                                                <a
                                                                  className="review-blue"
                                                                  onClick={() => {
                                                                    reviewNavigator(
                                                                      data,
                                                                      item,
                                                                      index
                                                                    );
                                                                  }}
                                                                >
                                                                  View Document
                                                                </a>
                                                              </td>
                                                            ) : (
                                                              <td
                                                                className="lastTab"
                                                                style={{
                                                                  border:
                                                                    "#fff",
                                                                }}
                                                              >
                                                                {currentStatus ===
                                                                  null &&
                                                                  (data?.template_type !==
                                                                    "i-9form" &&
                                                                  data?.template_type !==
                                                                    "w4-form" &&
                                                                  data?.template_type !==
                                                                    "W4Sc-form" ? (
                                                                    <a
                                                                      className="review-blue"
                                                                      onClick={() => {
                                                                        //  data?.fields[0]?.field_type_id===13?navigate("/dashboard/upload"): navigate("/dashboard/onboarding/edit-candidate-form", { state: { item: data } })
                                                                        editNavigateFunction(
                                                                          data
                                                                        );
                                                                      }}
                                                                    >
                                                                      Edit
                                                                    </a>
                                                                  ) : null)}
                                                                {console.log(
                                                                  "item item item",
                                                                  item
                                                                )}
                                                                {currentStatus !==
                                                                  null && (
                                                                  <div className="d-flex">
                                                                    <a
                                                                      className="review-blue case-blue"
                                                                      onClick={() => {
                                                                        //  data?.fields[0]?.field_type_id===13?navigate("/dashboard/upload"): navigate("/dashboard/onboarding/edit-candidate-form", { state: { item: data } })
                                                                        reviewNavigator(
                                                                          data,
                                                                          item,
                                                                          index
                                                                        );
                                                                      }}
                                                                    >
                                                                      View
                                                                    </a>
                                                                    {data.completed_status ===
                                                                      1 &&
                                                                    data
                                                                      ?.fields[0]
                                                                      ?.field_type_id !==
                                                                      13 &&
                                                                    data?.template_type !==
                                                                      "i-9form" &&
                                                                    data?.template_type !==
                                                                      "w4-form" &&
                                                                    data?.template_type !==
                                                                      "Ohio-it4-combined" &&
                                                                    data?.template_type !==
                                                                      "W4Sc-form" &&
                                                                    data?.template_type !==
                                                                      "MI-W4_Form" &&
                                                                    data?.template_type !==
                                                                      "L4-pdf" &&
                                                                    data?.template_type !==
                                                                      "AR4EC-pdf" ? (
                                                                      <button
                                                                        className="  download-icon case-left-down-icon2 visible-dw-btn"
                                                                        onClick={() => {
                                                                          openNewWindow(
                                                                            data
                                                                          );
                                                                        }}
                                                                      >
                                                                        <img
                                                                          src={
                                                                            Download
                                                                          }
                                                                          alt="test"
                                                                          className="files "
                                                                        />
                                                                      </button>
                                                                    ) : null}
                                                                    {data.employer_status ===
                                                                      1 &&
                                                                      data
                                                                        ?.fields[0]
                                                                        ?.field_type_id ===
                                                                        13 &&
                                                                      (data?.DownloadconvertedDoc !==
                                                                        "" ||
                                                                        data?.DownloadconvertedDoc !==
                                                                          null) && (
                                                                        <button
                                                                          className="download-icon case-left-down-icon2 visible-dw-btn"
                                                                          onClick={() => {
                                                                            handleTextFileData(
                                                                              profileDetails
                                                                                ?.chatbot
                                                                                ?.id,
                                                                              item?.interviewee_id,
                                                                              data?.DownloadconvertedDoc,
                                                                              data?.pdf_name
                                                                            );
                                                                          }}
                                                                        >
                                                                          <img
                                                                            src={
                                                                              Download
                                                                            }
                                                                            alt="test"
                                                                            className="files files "
                                                                          />
                                                                        </button>
                                                                      )}
                                                                    {data.employer_status ===
                                                                      1 &&
                                                                    (data?.template_type ===
                                                                      "i-9form" ||
                                                                      data?.template_type ===
                                                                        "w4-form" ||
                                                                      data?.template_type ===
                                                                        "Ohio-it4-combined" ||
                                                                      data?.template_type ===
                                                                        "W4Sc-form" ||
                                                                      data?.template_type ===
                                                                        "MI-W4_Form" ||
                                                                      data?.template_type ===
                                                                        "L4-pdf" ||
                                                                      data?.template_type ==
                                                                        "AR4EC-pdf") &&
                                                                    data?.Downloadleagalform !==
                                                                      "" &&
                                                                    data?.Downloadleagalform !==
                                                                      null ? (
                                                                      <button
                                                                        className="download-icon case-left-down-icon3"
                                                                        onClick={() => {
                                                                          downloadFile(
                                                                            API.legalFormsView +
                                                                              data?.Downloadleagalform
                                                                          );
                                                                        }}
                                                                      >
                                                                        {" "}
                                                                        <img
                                                                          src={
                                                                            Download
                                                                          }
                                                                          alt="test"
                                                                          className="files"
                                                                        />
                                                                      </button>
                                                                    ) : null}
                                                                    {data?.template_type ===
                                                                      "i-9form" &&
                                                                      data?.case_status !==
                                                                        null && (
                                                                        <div className="text-danger in-com tooltip caselogo-div">
                                                                          <img
                                                                            src={
                                                                              caselogo
                                                                            }
                                                                            alt="test"
                                                                            className="caselogo  "
                                                                          />
                                                                          <img
                                                                            src={
                                                                              caseimg
                                                                            }
                                                                            alt="test"
                                                                            className="caselogo "
                                                                          />
                                                                          <span class="tooltiptext">
                                                                            {
                                                                              data?.case_status_display
                                                                            }{" "}
                                                                          </span>
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                )}
                                                              </td>
                                                            )}
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                ) : null}
                                              </>
                                            ))}
                                            <div class="col-sm-12 mt-4">
                                              {isApproveShow &&
                                                showButton &&
                                                profileDetails?.onboarding_status !==
                                                  null && (
                                                  <button
                                                    type="button"
                                                    className={
                                                      isApprove
                                                        ? "update-btn rounded p-2 appro-btton"
                                                        : "update-btn rounded p-2 appro-btton-gray"
                                                    }
                                                    onClick={() => {
                                                      isApprove &&
                                                        setIsOpen(true);
                                                      setTempId(tempId);
                                                    }}
                                                  >
                                                    Approve
                                                  </button>
                                                )}
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}

                            {profileDetails?.onboarding_status !== null &&
                              !miniLoader &&
                              otherForms?.length === 0 &&
                              onBorardingStatus?.length === 0 && (
                                <h4 className="mx-3 no-msg">
                                  {isMyTeamPage
                                    ? "No forms found"
                                    : "Onboarding not began yet"}
                                </h4>
                              )}

                            {/* {isMyTeamPage ? ( */}
                            {/* ) : (
                              <div class="col-sm-12 mt-4">
                                {profileDetails?.onboarding_status !== null && (
                                  <button
                                    type="button"
                                    className={
                                      isApprove
                                        ? "update-btn rounded p-2 appro-btton"
                                        : "update-btn rounded p-2 appro-btton-gray"
                                    }
                                    onClick={() => {
                                      isApprove && setIsOpen(true);
                                    }}
                                  >
                                    Approve
                                  </button>
                                )}
                              </div>
                            )} */}
                          </div>
                        </TabPanel>

                        <TabPanel>
                          {(isMyTeamPage && profileDetails?.is_my_team === 0) ||
                          (!isMyTeamPage && caseId !== null) ? (
                            <div>
                              <div className="row">
                                <div className="col-12">
                                  <div className="">
                                    <span className="everify-head">
                                      Case Status
                                    </span>
                                    <p className="everify-head-para mt-2">
                                      {caseDetails?.case_status === "CLOSED" &&
                                      caseDetails?.case_eligibility_statement ===
                                        "EMPLOYMENT_AUTHORIZED" ? (
                                        <span className="employment-text-bg ">
                                          EMPLOYMENT AUTHORIZED
                                        </span>
                                      ) : caseDetails?.case_status ===
                                          "CLOSED" &&
                                        caseDetails?.case_eligibility_statement ===
                                          "NO_ACTION_FNC" ? (
                                        <span className="Final-text-bg ">
                                          FINAL NONCONFIRMATION
                                        </span>
                                      ) : caseDetails?.case_status ===
                                          "CLOSED" &&
                                        caseDetails?.case_eligibility_statement ===
                                          "NOT_AUTHORIZED_EMPLOYMENT" ? (
                                        <span className="Final-text-bg ">
                                          FINAL NONCONFIRMATION
                                        </span>
                                      ) : caseDetails?.case_status ===
                                          "CLOSED" &&
                                        caseDetails?.case_eligibility_statement ===
                                          "RESUBMIT_CASE" ? (
                                        <span className="Resubmit-text-bg ">
                                          CLOSED CASE AND RESUBMIT
                                        </span>
                                      ) : caseDetails?.case_status ===
                                          "CLOSE_CASE_AND_RESUBMIT" &&
                                        caseDetails?.case_eligibility_statement ===
                                          "RESUBMIT_CASE" ? (
                                        <span className="Resubmit-text-bg ">
                                          CLOSED CASE AND RESUBMIT
                                        </span>
                                      ) : caseDetails?.case_status ===
                                          "CLOSED" &&
                                        caseDetails?.case_eligibility_statement ===
                                          null ? (
                                        <span className="Final-text-bg ">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "MANUAL_REVIEW" ? (
                                        <span className="emp-dhs-bg">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "PHOTO_MATCH" ? (
                                        <span className="emp-dhs-bg">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "PENDING_REFERRAL" ? (
                                        <span className="tent-non-bg">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "REFERRED" ? (
                                        <span className="emp-dhs-bg">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "QUEUED" ? (
                                        <span className="emp-dhs-bg">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "DRAFT" ? (
                                        <span className="case-incom">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "FINAL_NONCONFIRMATION" ? (
                                        <span className="Final-text-bg ">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : caseDetails?.case_status ===
                                        "UNCONFIRMED_DATA" ? (
                                        <span className="case-incom">
                                          {caseDetails?.case_status_display.toUpperCase()}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Case Number
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.case_number}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Date of Case Creation
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(caseDetails?.created_date).format(
                                        "MMMM D, YYYY"
                                      )}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      First Day of Employment
                                    </span>
                                    <p className="everify-head-para">
                                      {" "}
                                      {moment(caseDetails?.date_of_hire).format(
                                        "MMMM D, YYYY"
                                      )}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Client Company
                                    </span>
                                    <p className="everify-head-para">
                                      {" "}
                                      {caseDetails?.case_creator_name}
                                    </p>
                                  </div>
                                </div>

                                <div class="col-12">
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Citizenship Status
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.citizenship_status_code ===
                                      "US_CITIZEN"
                                        ? "A citizen of the United States"
                                        : caseDetails?.citizenship_status_code ===
                                          "NONCITIZEN"
                                        ? "A noncitizen national of the United States"
                                        : caseDetails?.citizenship_status_code ===
                                          "LAWFUL_PERMANENT_RESIDENT"
                                        ? "A lawful permanent resident"
                                        : caseDetails?.citizenship_status_code ===
                                          "NONCITIZEN_AUTHORIZED_TO_WORK"
                                        ? "A noncitizen authorized to work until (exp. date, if any)"
                                        : null}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      Date of Birth{" "}
                                    </span>
                                    <p className="everify-head-para">
                                      {moment(
                                        caseDetails?.date_of_birth
                                      ).format("MMMM D, YYYY")}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      U.S. Social Sec. Number
                                    </span>
                                    <p className="everify-head-para">
                                      ** ** {caseDetails?.ssn?.slice(-4)}
                                    </p>
                                  </div>
                                  <div className="everify-column">
                                    <span className="everify-head">
                                      {" "}
                                      Case Created By
                                    </span>
                                    <p className="everify-head-para">
                                      {caseDetails?.client_company_id}(
                                      {caseDetails?.case_creator_name})
                                    </p>
                                  </div>
                                </div>
                                {caseDetails?.document_a_type_code !== null ? (
                                  <>
                                    {caseDetails?.document_a_type_code ===
                                      "US_PASSPORT" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            U.S. Passport or Passport Card
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.us_passport_number}
                                          </p>
                                        </div>
                                        {/* <div className="everify-column">
        <span className="everify-head">Issuing Authority</span>
          <p className="everify-head-para">FL</p>
        </div> */}
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Document Expiration
                                          </span>
                                          <p className="everify-head-para">
                                            {moment(
                                              caseDetails?.expiration_date
                                            ).format("MMMM D, YYYY")}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {caseDetails?.document_a_type_code ===
                                      "FORM_I94_RECEIPT" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            Arrival/Departure Record (Form I-94)
                                            with temporary I-551 stamp or
                                            refugee admission stamp (receipt)
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Document Expiration
                                          </span>
                                          <p className="everify-head-para">
                                            {moment(
                                              caseDetails?.expiration_date
                                            ).format("MMMM D, YYYY")}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {caseDetails?.document_a_type_code ===
                                      "FORM_I551" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            Permanent Resident Card or Alien
                                            Registration Receipt Card (Form
                                            I-551)
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.i551_number}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {caseDetails?.document_a_type_code ===
                                      "FOREIGN_PASSPORT_WITH_I551_STAMP" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            Foreign passport with temporary
                                            I-551 stamp or printed notation on a
                                            MRIV
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {
                                              caseDetails?.foreign_passport_number
                                            }
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Document Expiration
                                          </span>
                                          <p className="everify-head-para">
                                            {moment(
                                              caseDetails?.expiration_date
                                            ).format("MMMM D, YYYY")}{" "}
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Country of Issuance
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.country_code}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}

                                    {caseDetails?.document_a_type_code ===
                                      "FORM_I766" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            Employment Authorization Document
                                            (Form I-766)
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.i766_number}
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Document Expiration
                                          </span>
                                          <p className="everify-head-para">
                                            {moment(
                                              caseDetails?.expiration_date
                                            ).format("MMMM D, YYYY")}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {caseDetails?.document_a_type_code ===
                                      "FOREIGN_PASSPORT_WITH_FORM_I94" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List A Document
                                          </span>
                                          <p className="everify-head-para">
                                            Foreign passport with
                                            Arrival/Departure Record (Form I-94)
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {
                                              caseDetails?.foreign_passport_number
                                            }
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Issuing Authority
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.country_code}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {caseDetails?.document_b_type_code ===
                                      "DRIVERS_LICENSE" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List B Document
                                          </span>
                                          <p className="everify-head-para">
                                            Driver's license or ID card issued
                                            by a U.S. state or outlying
                                            possession
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            Document Number{" "}
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.document_bc_number}
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            State
                                          </span>
                                          <p className="everify-head-para">
                                            {caseDetails?.us_state_code}
                                          </p>
                                        </div>
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            {" "}
                                            Document Expiration
                                          </span>
                                          <p className="everify-head-para">
                                            {moment(
                                              caseDetails?.expiration_date
                                            ).format("MMMM D, YYYY")}{" "}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                    {caseDetails?.document_b_type_code !==
                                      "DRIVERS_LICENSE" && (
                                      <div className="col-12">
                                        <div className="everify-column">
                                          <span className="everify-head">
                                            List B Document
                                          </span>
                                          <p className="everify-head-para">
                                            {loader === false &&
                                              getDocName(
                                                "LIST_B",
                                                caseDetails?.document_b_type_code
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                    )}

                                    <div className="col-12">
                                      <div className="everify-column">
                                        <span className="everify-head">
                                          List C Document
                                        </span>
                                        <p className="everify-head-para">
                                          {loader === false &&
                                            getDocName(
                                              "LIST_C",
                                              caseDetails?.document_c_type_code
                                            )}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>

                              <div className="col-12">
                                <div className="col-6"></div>

                                <div className="col-3 on-everify">
                                  <div class="d-flex align-items-center  m-0">
                                    {/* <button className="submits-btn rounded p-2 sub-bttn-right-sides-download-ev">Check Status</button> */}
                                    <button
                                      className="submits-btn rounded p-2 sub-bttn-right-sides-ev Contine-Case"
                                      onClick={() => {
                                        navigate(
                                          "/dashboard/review/" +
                                            caseDetails?.interviewee_id +
                                            "/" +
                                            caseDetails?.case_number
                                        );
                                      }}
                                    >
                                      {caseDetails?.case_status === "CLOSED"
                                        ? "View Case"
                                        : "Continue Case"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </TabPanel>

                        <TabPanel>
                          <div className="iner-sc scrlHe-tab pr-3">
                            {applicationHistory?.length !== 0 ? (
                              <table
                                class="table mt-4 app-his-scrll"
                                border={1}
                              >
                                <thead className="table-text">
                                  <tr>
                                    <th className="pl-0" scope="col">
                                      Job Title
                                    </th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Date Applied</th>
                                    {/* ///hiding this for live build please uncomment */}
                                    {/* <th scope="col">Actions</th> */}
                                  </tr>
                                </thead>
                                <tbody className="table-text-body">
                                  {applicationHistory.map((item, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td
                                            className="pl-0 d-flex align-items-center firstTab "
                                            onClick={() => {
                                              historyToggleHandler(index);
                                            }}
                                          >
                                            {item?.chatbot?.chatbot_name}{" "}
                                            {item?.count > 1 && (
                                              <span className="count-t ms-3">
                                                {item?.count}
                                              </span>
                                            )}{" "}
                                          </td>
                                          <td
                                            onClick={() => {
                                              historyToggleHandler(index);
                                            }}
                                          >
                                            {
                                              item?.chatbot?.customuser
                                                ?.company_name
                                            }
                                          </td>
                                          <td
                                            onClick={() => {
                                              historyToggleHandler(index);
                                            }}
                                          >
                                            {item.created_at}
                                          </td>

                                          <button
                                            type="button"
                                            class="btn btn-info btn-lg mesg-bttn"
                                            data-toggle="modal"
                                            data-target="#myModal"
                                            onClick={() => {
                                              console.log(
                                                applicationHistory[index]
                                              );
                                              setConversationModalData(
                                                applicationHistory[index]
                                              );
                                              setIsConversationModalOpen(true);
                                            }}
                                          >
                                            <img
                                              src={Messageicon}
                                              alt="test"
                                              className="mesg-icon"
                                            />
                                          </button>
                                          {/* ///hiding this for live build please uncomment */}
                                          {/* <td><a href='#'>View</a></td> */}
                                        </tr>

                                        {onClickHistoryToggle === true &&
                                          onClickHistoryIndex === index && (
                                            <>
                                              {applicationHistory[
                                                onClickHistoryIndex
                                              ]?.conversation?.answers
                                                ?.length === 0 ? (
                                                <tr>
                                                  <td colspan="4">
                                                    <table
                                                      class="w-100 table-bordered mt-4"
                                                      border="1"
                                                    >
                                                      <tr>
                                                        <td>Name</td>
                                                        <td>
                                                          <p class="name-alin">
                                                            {
                                                              profileDetails?.first_name
                                                            }
                                                          </p>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>Email</td>
                                                        <td>
                                                          <p class="name-alin">
                                                            <a href="">
                                                              {
                                                                profileDetails?.email
                                                              }
                                                            </a>
                                                          </p>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>Phone</td>
                                                        <td>
                                                          <p class="name-alin">
                                                            <a href="">
                                                              {
                                                                profileDetails?.phone
                                                              }
                                                            </a>
                                                          </p>
                                                        </td>
                                                      </tr>
                                                    </table>
                                                  </td>
                                                </tr>
                                              ) : (
                                                <>
                                                  {applicationHistory[
                                                    onClickHistoryIndex
                                                  ]?.conversation?.answers?.map(
                                                    (data) => {
                                                      return (
                                                        <tr border="1">
                                                          <td
                                                            c
                                                            olspan="3"
                                                            style={{
                                                              border:
                                                                "solid 1px #E8E8E8",
                                                            }}
                                                          >
                                                            {data?.column_name}
                                                          </td>
                                                          {/* <td></td> */}
                                                          <td
                                                            td
                                                            colspan="3"
                                                            style={{
                                                              textAlign: end,
                                                              border:
                                                                "solid 1px #E8E8E8",
                                                            }}
                                                          >
                                                            <p class="name-alin">
                                                              {
                                                                data?.answer_text
                                                              }
                                                            </p>
                                                          </td>
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                      </>
                                    );
                                  })}
                                </tbody>
                              </table>
                            ) : (
                              <h4 className="mx-3 no-msg">No History Found</h4>
                            )}
                          </div>
                        </TabPanel>

                        <TabPanel>
                          <div className="iner-sc scrlHe-tab pr-3">
                            {/* <div className='cattchmentsX mt-4'>
                                                  <div className='attch-itms '>
                                                      <div className='hd-attach mb-4'>
                                                          <img src={sdot} alt="test" className="sdots" />
                                                          <h3>CV</h3>
                                                          <img src={Add} alt="test" className="sAdd" />
                                                      </div>
                                                      <div className='attachment-file-view'>
                                                          <div className='row'>
                                                              <div className='col-lg-6'>
                                                                  <div className='file-view'>
                                                                      <div className='file-info d-flex align-items-center '>
                                                                          <img src={File} alt="test" className="files mr-3" />
                                                                          <h5 className='mb-0' >offer letter</h5>
                                                                      </div>
                                                                      <img src={sample} alt="test" className="sample-f" />
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-6'>
                                                                  <div className='file-view'>
                                                                      <div className='file-info d-flex align-items-center '>
                                                                          <img src={File} alt="test" className="files mr-3" />
                                                                          <h5 className='mb-0' >offer letter</h5>
                                                                      </div>
                                                                      <img src={sample} alt="test" className="sample-f" />
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>

                                                  </div>
                                                  <div className='attch-itms mt-5'>
                                                      <div className='hd-attach mb-4'>
                                                          <img src={sdot} alt="test" className="sdots" />
                                                          <h3>Folders</h3>
                                                          <img src={Add} alt="test" className="sAdd" />
                                                      </div>
                                                      <div className='attachment-file-view'>
                                                          <div className='row'>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Emergency</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Timecards</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Timecards</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Old Tax</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Emergency</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Timecards</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Emergency</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Emergency</h5>
                                                                  </div>
                                                              </div>
                                                              <div className='col-lg-4'>
                                                                  <div className='folder-itm d-flex justify-content-center align-items-center file-view'>
                                                                      <img src={Folder} alt="test" className="files" />
                                                                      <h5 className='mb-0' >Emergency</h5>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </div>

                                                  </div>
                                              </div> */}

                            <div>
                              <div className="my-0 mx-0 mb-0 topAlg">
                                <div className="row">
                                  <div className="col-md-7 docBrad">
                                    {/* <Breadcrumb>
                                                    <Breadcrumb.Item href="#">
                                                      Business Documents
                                                    </Breadcrumb.Item>
                                                    <Breadcrumb.Item active>
                                                      Weekly Reports
                                                    </Breadcrumb.Item>
                                                  </Breadcrumb> */}
                                  </div>
                                  <div className="col-md-5 d-flex justify-content-between up-down-btn">
                                    <div className="f-btns doc">
                                      <button onClick={handleDownloadZip}>
                                        <img
                                          src={downloadicon}
                                          alt="test"
                                          className="document-image"
                                        />{" "}
                                        Download Files
                                      </button>{" "}
                                    </div>
                                    <span
                                      style={{
                                        color: "rgb(102 102 102 / 29%)",
                                      }}
                                    >
                                      &nbsp;|&nbsp;
                                    </span>
                                    <div
                                      className="btn pl-0"
                                      onClick={() => {
                                        setIsUpload(!isUpload);
                                      }}
                                    >
                                      <img
                                        src={uploadicon}
                                        alt="test"
                                        className="document-image"
                                        // onClick={() => {
                                        //   setIsUpload(!isUpload);
                                        // }}
                                      />
                                      Upload Files
                                    </div>
                                  </div>

                                  <div className="col-lg-12 d-flex justify-content-between">
                                    {isUpload && (
                                      <div className="Documents-upload">
                                        <input
                                          type="file"
                                          className="doct-choose"
                                          ref={fileInputRef}
                                          onChange={(e) => {
                                            setDoc(e.target.files[0]);
                                          }}
                                        />
                                        <button
                                          className="btn btn-primary doct-upload"
                                          onClick={uploadDoc}
                                        >
                                          Upload
                                        </button>
                                      </div>
                                    )}

                                    {/* <img src={documentimage} alt="test" className="document-image" onClick={() => { setIsUpload(!isUpload) }} /> */}
                                  </div>
                                </div>
                                <hr />
                              </div>
                              {/* <input type='file' onChange={(e) => { setDoc(e.target.files[0]) }} />
                                                                        <button className=' btn btn-primary' onClick={uploadDoc}>Upload</button>*/}
                              {documents?.chatbotFiles?.length === 0 &&
                              documents?.ConfirmedFiles?.length === 0 &&
                              documents?.OnboardingFiles?.length === 0 &&
                              documents?.OfferLetters?.length === 0 ? (
                                <h4 className="mx-3 no-msg">
                                  No Documents Found
                                </h4>
                              ) : (
                                <div className="tables docTable">
                                  <table className="table mt-0">
                                    <tbody className="table-text-body">
                                      {documents?.chatbotFiles?.map((item) => {
                                        return (
                                          <tr>
                                            <td className="pl-0">
                                              <img
                                                src={filetext}
                                                alt="test"
                                                className="files "
                                              />
                                              {item?.answer_text
                                                ?.split("_")
                                                ?.pop()}
                                            </td>

                                            <td>
                                              {moment(item.created_at).format(
                                                "MMM DD, YYYY"
                                              )}
                                            </td>

                                            <td className="tabLast_ch">
                                              <div className="f-btns doc">
                                                <button
                                                  onClick={() => {
                                                    downloadFile(
                                                      API.avenuView +
                                                        item?.answer_text
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={Download}
                                                    alt="test"
                                                    className="files"
                                                  />
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    setDeletePopupData(item);
                                                    setDocumentType(
                                                      "chatbotfiles"
                                                    );
                                                    setIsDeletePopupOpen(true);
                                                    console.log(item);
                                                  }}
                                                >
                                                  <img
                                                    src={Trash}
                                                    alt="test"
                                                    className="files"
                                                  />
                                                </button>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}

                                      {recDocs?.map((item) => {
                                        return (
                                          <tr>
                                            <td className="pl-0">
                                              <img
                                                src={filetext}
                                                alt="test"
                                                className="files "
                                              />
                                              {item?.split("/")?.pop()}
                                            </td>

                                            <td>
                                              {moment(item?.created_at).format(
                                                "MMM DD, YYYY"
                                              )}
                                            </td>

                                            <td className="tabLast_ch">
                                              <div className="f-btns doc">
                                                <button
                                                  onClick={() => {
                                                    downloadFile(
                                                      API.avenuView + item
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src={Download}
                                                    alt="test"
                                                    className="files"
                                                  />
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    setDeletePopupData(item);
                                                    setDocumentType(
                                                      "offerletters"
                                                    );
                                                    setIsDeletePopupOpen(true);
                                                    console.log(item);
                                                  }}
                                                >
                                                  <img
                                                    src={Trash}
                                                    alt="test"
                                                    className="files"
                                                  />
                                                </button>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                      {documents?.OnboardingFiles?.map(
                                        (item) => {
                                          return (
                                            <tr>
                                              <td className="rowz-width">
                                                <img
                                                  src={filetext}
                                                  alt="test"
                                                  className="files"
                                                />
                                                {item.name?.split("_")?.pop()}
                                              </td>
                                              {/*<td>
                                              {" "}
                                            <span className='yllowstatus' >Corporate Paperwork</span>
                                            </td>*/}
                                              <td>
                                                {moment(item.created_at).format(
                                                  "MMM DD, YYYY"
                                                )}
                                              </td>
                                              <td className="tabLast_ch">
                                                <div className="f-btns doc">
                                                  <button
                                                    onClick={() => {
                                                      downloadFile(
                                                        API.mediaView +
                                                          "file-library/" +
                                                          profileDetails.chatbot_id +
                                                          "/" +
                                                          profileDetails.id +
                                                          "/onboarding/" +
                                                          item.name
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={Download}
                                                      alt="test"
                                                      className="files"
                                                    />
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setDeletePopupData(item);
                                                      setDocumentType(
                                                        "onboardingfiles"
                                                      );
                                                      console.log(item);
                                                      setIsDeletePopupOpen(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={Trash}
                                                      alt="test"
                                                      className="files"
                                                    />
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                      {documents?.ConfirmedFiles?.map(
                                        (item) => {
                                          console.log("item-->", item.name);
                                          return (
                                            <tr>
                                              <td className="rowz-width">
                                                <img
                                                  src={filetext}
                                                  alt="test"
                                                  className="files"
                                                />
                                                {item.pdf_name}
                                              </td>
                                              <td>
                                                {moment(item.created_at).format(
                                                  "MMM DD, YYYY"
                                                )}
                                              </td>
                                              <td className="tabLast_ch">
                                                <div className="f-btns doc">
                                                  {(item?.pdf_document !== "" ||
                                                    item?.pdf_document !==
                                                      null) && (
                                                    <button
                                                      onClick={() => {
                                                        item?.formfield_id ===
                                                        null
                                                          ? downloadFile(
                                                              API.legalFormsView +
                                                                item?.pdf_document
                                                            )
                                                          : handleTextFileData(
                                                              item?.chatbot_id,
                                                              item?.interviewee_id,
                                                              item?.pdf_document,
                                                              item?.pdf_name
                                                            );
                                                      }}
                                                    >
                                                      <img
                                                        src={Download}
                                                        alt="test"
                                                        className="files"
                                                      />
                                                    </button>
                                                  )}
                                                  <button
                                                    onClick={() => {
                                                      setDeletePopupData(item);
                                                      setDocumentType(
                                                        "confirmpdf"
                                                      );
                                                      console.log(item);
                                                      setIsDeletePopupOpen(
                                                        true
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src={Trash}
                                                      alt="test"
                                                      className="files"
                                                    />
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>

                            {/* 
                                                      <input type='file' onChange={(e) => { setDoc(e.target.files[0]) }} />
                                                      <button className=' btn btn-primary' onClick={uploadDoc}>Upload</button> */}
                            {/*<div class="container-upload">
                                                          <form class="form">
                                                              <div class="file-upload-wrapper" data-text="Select your file!">
                                                                  <input name="file-upload-field" type="file" class="file-upload-field" onChange={(e) => { setDoc(e.target.files[0]) }} />

                                                                  <button class="browse input-group-text btn btn-primary" id="basic-addon2" onClick={(e) => { e.preventDefault(); uploadDoc() }}><i class="fas fa-search"></i>Upload</button>

                                                              </div>
                                                          </form>
                                                      </div>*/}

                            {/* <div className='cattchmentsX mt-4'>
                                                          <div className='attch-itms '>

                                                              <div className='attachment-file-view'>
                                                                  <div className='row'>
                                                                      {documents?.chatbotFiles?.map((item) => {
                                                                          return (
                                                                              <div className='col-lg-6'>
                                                                                  <div className='file-view'>
                                                                                      <div className='file-info d-flex align-items-center '>
                                                                                          <img src={File} alt="test" className="files mr-3" />
                                                                                          <h5 className='mb-0' >{item.name}</h5>
                                                                                      </div>
                                                                                      <img src={sample} alt="test" className="sample-f" />
                                                                                  </div>
                                                                              </div>
                                                                          )
                                                                      })}
                                                                  </div>
                                                              </div>
                                                              <div className='attachment-file-view'>
                                                                  <div className='row'>
                                                                      {documents?.OnboardingFiles?.map((item) => {
                                                                          return (
                                                                              <div className='col-lg-6'>
                                                                                  <div className='file-view'>
                                                                                      <div className='file-info d-flex align-items-center '>
                                                                                          <img src={File} alt="test" className="files mr-3" />
                                                                                          <h5 className='mb-0' >{item.name}</h5>
                                                                                      </div>
                                                                                      <img src={sample} alt="test" className="sample-f" />
                                                                                  </div>
                                                                              </div>
                                                                          )
                                                                      })}
                                                                  </div>
                                                              </div>

                                                          </div>
                                                      </div>*/}
                          </div>
                        </TabPanel>

                        <TabPanel>
                          <div className="iner-sc pr-3 candScroll scrlHe-tab top-space-tag scroll1 top-spaceing">
                            {/*<div className="accordion accordion-flush" id="tags"> </div>*/}

                            <div className="wraper">
                              <div className="accordion-item">
                                <h2 className="accordion-header newOne">
                                  <div className="secTag">
                                    <a className="nav-link">
                                      <span className="menu-title">
                                        Tags{" "}
                                        <button
                                          className="add-submenuz"
                                          onClick={() => {
                                            isSetTag(!istag);
                                          }}
                                        >
                                          <img
                                            src={tagAdd}
                                            alt="test"
                                            className="add_icon"
                                          />
                                        </button>
                                      </span>
                                    </a>
                                    {/* <img src={tagAdd} alt="test" className="tag-img" /> */}
                                  </div>
                                  <div
                                    className="accordion-button collapsed tag"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#tag1"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseOne"
                                  ></div>
                                </h2>

                                <div
                                  id="tag1"
                                  className="accordion-collapse collapse show"
                                  data-bs-parent="#tags"
                                >
                                  {/* <input className='form-control mx-4 mb-2' style={{ width: '50%', height: '40%' }} value={newTag} onChange={(e) => {  setNewTag(e.target.value) }} onKeyDown={(event) => { addTags(event) }} /> */}
                                  <div className="accordion-body">
                                    {istag && (
                                      <input
                                        className="form-control mb-3"
                                        style={{ width: "40%", height: "30px" }}
                                        value={newTag}
                                        onChange={(e) => {
                                          setNewTag(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                          addTagsOnBlur(e);
                                        }}
                                        onKeyDown={(e) => {
                                          addTags(e);
                                        }}
                                      />
                                    )}

                                    <div class="topnav">
                                      {/* {tags !== [""] && */}
                                      {tags.map((item) => {
                                        return (
                                          item !== "" && (
                                            <a className="active tage-menu">
                                              <p className="tage-text">
                                                {item}
                                              </p>
                                              <img
                                                src={Close}
                                                alt="test"
                                                className="close-image"
                                                onClick={() => [
                                                  removeTag(item, index),
                                                ]}
                                              />
                                            </a>
                                          )
                                        );
                                      })}
                                      {/* {tags === [""] && (
                                        <p className="tage-text">
                                          No Tags Found
                                        </p>
                                      )} */}
                                    </div>

                                    {/* {/* <ul className="nav submenu tag-grp">
                                                                                            {tags !== [] && tags.map((item) => {
                                                                                                return (
                                                                                                    item !== '' && <li>
                                                                                                        <span className='tag-design'><button className='tag-btn' >
                                                                                                            <p className="deatails-tap-text" >{item}</p>
                                                                                                            <img src={Close} alt="test" className="close-image" onClick={() => [removeTag(item, index)]} />
                                                                                                        </button>
                                                                                                        </span>notes-box
                                                                                                    </li>)
                                                                                            })} */}
                                    {/* {tags === [''] && <p> gggggggggggg</p>}
                                                                                            {tags === [] && <p> gggggggggggg</p>} */}
                                    {/* <li>
                                                                                                    <span className='tag-design'><button className='tag-btn' >
                                                                                                        <p className="deatails-tap-text" >No tags</p>
                                                                                                        <img src={Close} alt="test" className="close-image" />
                                                                                                    </button>
                                                                                                    </span>
                                                                                                </li>} */}
                                  </div>
                                  <span className="notes-title">
                                    Notes
                                    {/*<button className='add-submenuz' >
                                                                                <img src={Add} alt="test" className="add_icon" /></button>*/}
                                  </span>

                                  <div className="textarea-part mb-3">
                                    <textarea
                                      type="textarea"
                                      className="mt-1 textarea notes-box"
                                      id="floatingInput"
                                      placeholder="Enter notes here..."
                                      value={comment !== null ? comment : ""}
                                      onChange={(e) => {
                                        setComments(e.target.value);
                                      }}
                                      onBlur={(e) => {
                                        addCommentsOnBlur(e);
                                      }}
                                      onKeyDown={(e) => {
                                        addComments(e);
                                      }}
                                    ></textarea>
                                    {/*<label for="floatingInput" className="nores-text" >Enter notes here...</label>*/}
                                  </div>
                                </div>

                                <div className="accordion-item">
                                  <h2 className="accordion-header mb-1">
                                    <div>
                                      {/*<a href="#" className="nav-link">
                                          <span className="notes-title">
                                            Report Card{" "}
                                            <button className="add-submenuz"></button>
                                          </span>
                                        </a>*/}

                                      <span className="notes-title">
                                        Report Card{" "}
                                      </span>
                                    </div>

                                    {/* <button className="accordion-button collapsed tag" type="button" data-bs-toggle="collapse" data-bs-target="#Report" aria-expanded="false" aria-controls="flush-collapseOne">
                                                                                <a href='#' className="nav-link">
                                                                                    <span className="menu-title">Report Card</span>
                                                                                </a>
                                                                            </button>*/}
                                  </h2>
                                  {/*<div id="Report" className="accordion-collapse collapse" data-bs-parent="#tags"></div>*/}
                                  <div className="accordion-body p-0">
                                    <div className="table-responsive">
                                      <table
                                        className="w-100 table-bordered"
                                        border={1}
                                      >
                                        {chatbotsAnwers?.answers?.length ===
                                        0 ? (
                                          <>
                                            <tr>
                                              <td>Name</td>
                                              <td>
                                                {editName ? (
                                                  <input
                                                    className="on-details-edits"
                                                    value={reportName}
                                                    onChange={(e) => {
                                                      setReportName(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "name",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    {profileDetails?.last_name !=
                                                    null
                                                      ? profileDetails?.first_name +
                                                        " " +
                                                        profileDetails?.last_name
                                                      : profileDetails?.first_name}
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.last_name !=
                                                        null
                                                        ? profileDetails?.first_name +
                                                            " " +
                                                            profileDetails?.last_name
                                                        : profileDetails?.first_name
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setEditName(!editName);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Email</td>
                                              <td>
                                                {editEmail ? (
                                                  <input
                                                    value={reportEmail}
                                                    onChange={(e) => {
                                                      setReportEmail(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "email",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    <a href="">
                                                      {profileDetails?.email}
                                                    </a>
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.first_name
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setEditEmail(!editEmail);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Phone</td>
                                              <td>
                                                {editPhone ? (
                                                  <input
                                                    value={reportPhone}
                                                    onChange={(e) => {
                                                      setReportPhone(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "phone",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    <a href="">
                                                      {profileDetails?.phone}
                                                    </a>
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.first_name
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setEditPhone(!editPhone);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                          </>
                                        ) : (
                                          <>
                                            <tr>
                                              <td>Name</td>
                                              <td>
                                                {editName ? (
                                                  <input
                                                    value={reportName}
                                                    onChange={(e) => {
                                                      setReportName(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "name",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    {profileDetails?.last_name !=
                                                    null
                                                      ? profileDetails?.first_name +
                                                        " " +
                                                        profileDetails?.last_name
                                                      : profileDetails?.first_name}
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.last_name !=
                                                        null
                                                        ? profileDetails?.first_name +
                                                            " " +
                                                            profileDetails?.last_name
                                                        : profileDetails?.first_name
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setEditName(!editName);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Email</td>
                                              <td>
                                                {editEmail ? (
                                                  <input
                                                    value={reportEmail}
                                                    onChange={(e) => {
                                                      setReportEmail(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "email",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    <a href="">
                                                      {profileDetails?.email}
                                                    </a>
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.first_name
                                                    );
                                                    setReportLastName(
                                                      profileDetails?.last_name
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setEditEmail(!editEmail);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Phone</td>
                                              <td>
                                                {editPhone ? (
                                                  <input
                                                    value={reportPhone}
                                                    onChange={(e) => {
                                                      setReportPhone(
                                                        e.target.value
                                                      );
                                                    }}
                                                    onBlur={() =>
                                                      editDetails(
                                                        "phone",
                                                        profileDetails?.chatbot
                                                          ?.id
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <p className="name-alin">
                                                    <a href="">
                                                      {profileDetails?.phone}
                                                    </a>
                                                  </p>
                                                )}
                                                <button
                                                  type="button"
                                                  class="edit_icon ml-2"
                                                  onClick={() => {
                                                    setReportName(
                                                      profileDetails?.first_name
                                                    );
                                                    setReportLastName(
                                                      profileDetails?.last_name
                                                    );
                                                    setReportPhone(
                                                      profileDetails?.phone
                                                    );
                                                    setReportEmail(
                                                      profileDetails?.email
                                                    );
                                                    setEditPhone(!editPhone);
                                                  }}
                                                >
                                                  <img
                                                    src={Editic}
                                                    alt="test"
                                                    className="icon"
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                            {chatbotsAnwers?.answers?.map(
                                              (item) => {
                                                return (
                                                  item?.column_name !==
                                                    "Otp Answer" && (
                                                    <>
                                                      {item?.column_name !==
                                                        "Name" &&
                                                      item?.column_name !==
                                                        "Email" &&
                                                      item?.column_name !==
                                                        "Phone" ? (
                                                        <tr>
                                                          <td>
                                                            {item?.column_name}
                                                          </td>
                                                          <td>
                                                            {item?.answer_text}
                                                          </td>
                                                        </tr>
                                                      ) : null}
                                                    </>
                                                  )
                                                );
                                              }
                                            )}
                                          </>
                                        )}
                                        {/* <tr>
                                                                                    <td>Name</td>
                                                                                    <td>{profileDetails.first_name}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Email</td>
                                                                                    <td className="email-table">{profileDetails.email}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Phone Number</td>
                                                                                    <td>{profileDetails.phone}</td>
                                                                                </tr> */}
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/*<div className='col-lg-8'>
                                                                            <div className="accordion-item">
                                                                                {/*} <h2 className="accordion-header">
                                                                                    <div className="accordion-button collapsed tag" type="button" data-bs-toggle="collapse" data-bs-target="#tag2" aria-expanded="false" aria-controls="flush-collapseOne">
                                                                                        <a href='#' className="nav-link">
                                                                                            <span className="menu-title">Notes<button className='add-submenuz' ><img src={Add} alt="test" className="add_icon" /></button></span>
                                                                                        </a>
                                                                                    </div>
                                                                                </h2>
                                                                                <div id="tag2" className="accordion-collapse collapse show" data-bs-parent="#tags">
                                                                                    <div className="accordion-body notes">
                                                                                        {editComment === true ? <textarea className='form-control' value={comment} onChange={(e) => { setComments(e.target.value) }} onKeyDown={addComments} /> : <p className="commt-text" onClick={() => { setEditComment(true) }}>{comment === '' || comment === null ? 'No comments' : comment}</p>}
                                                                                        {editComment === false && <span className="commt-date">15 April, 2022</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>*/}
                            </div>

                            {/* <div className="accordion-item">
                                                              <h2 className="accordion-header">
                                                                  <button className="accordion-button collapsed tag" type="button" data-bs-toggle="collapse" data-bs-target="#check" aria-expanded="false" aria-controls="flush-collapseOne">
                                                                      <a href='#' className="nav-link">
                                                                          <span className="menu-title">Background Check <button className='add-submenuz' ><img src={Add} alt="test" className="add_icon" /></button></span>
                                                                      </a>
                                                                  </button>
                                                              </h2>
                                                              <div id="check" className="accordion-collapse collapse" data-bs-parent="#tags">
                                                                  <div className="accordion-body p-0">
                                                                      <div className='bg-check'>
                                                                          <div className='d-flex justify-content-between bg-c '>
                                                                              <h6>Basic</h6>
                                                                              <button className='inv-saend mb-2' >Invitation Send</button>
                                                                          </div>
                                                                          <div className='d-flex justify-content-between bg-c'>
                                                                              <soan className="sub-text">Expired on Feb 3, 2022 2:59 AM EST</soan>
                                                                              <a href='#' className="sub-text-link">View Candidate</a>
                                                                          </div>
                                                                      </div>
                                                                  </div>



                                                                  <div className="accordion-body p-0">
                                                                      <div className='bg-check'>
                                                                          <div className='d-flex justify-content-between bg-c '>
                                                                              <h6>Basic</h6>
                                                                              <button className='inv-saend mb-2' >Clear</button>
                                                                          </div>
                                                                          <div className='d-flex justify-content-between bg-c'>
                                                                              <soan className="sub-text">Completed at Feb 3, 2022 2:59 AM EST</soan>
                                                                              <a href='#' className="sub-text-link">View Candidate</a>
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>*/}
                          </div>
                        </TabPanel>

                        <TabPanel className="pr-3">
                          {/* {messages?.answers?.length !== 0 ? ( */}
                          <div className="chat iner-sc candScroll scrlHe-tab scroll1 msg_history scroll msgScroll">
                            <div className="wrapp">
                              {messages?.map((item, index) => {
                                return (
                                  <div
                                    className="chatarea"
                                    id={index}
                                    ref={
                                      index === messages?.length - 1
                                        ? lastMessageRef
                                        : null
                                    }
                                  >
                                    {item?.is_interviewee_msg === 1 && (
                                      <div className="replay">
                                        <div className="replay-main">
                                          <div className="replayav">
                                            <div
                                              className="avatar"
                                              style={{
                                                backgroundColor: "#41D1FF",
                                              }}
                                            >
                                              {getAvatar(
                                                profileDetails?.first_name
                                              )}
                                            </div>
                                            <div className="chat-content chat-content-bg">
                                              <p
                                                style={{
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                }}
                                                // dangerouslySetInnerHTML={{
                                                //   __html: item.question_text
                                                //     .replace(
                                                //       "{name}",
                                                //       chatbotsAnwers?.replace_to_name
                                                //     )
                                                //     .replace(
                                                //       "{method} ",
                                                //       chatbotsAnwers?.replace_to_method
                                                //     )
                                                //     .replace(
                                                //       "{method}",
                                                //       chatbotsAnwers?.replace_to_method
                                                //     ),
                                                // }}
                                              >
                                                {item?.message_text}
                                              </p>
                                            </div>
                                          </div>
                                          <span class="time_date-left">
                                            {" "}
                                            {moment(item?.created_at).format(
                                              "DD MMM"
                                            )}
                                            . {item?.created_at?.slice(-8)} via{" "}
                                            {item?.platform}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    {item?.is_interviewer_msg === 1 && (
                                      <div className="replay request">
                                        <div className="replay-main">
                                          <div className="replayav">
                                            <div className="chat-content chat-content-bg2">
                                              <p
                                                style={{
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                {item?.message_text}
                                              </p>
                                            </div>
                                            <div className="chatProf">
                                              <img
                                                src={AvenuChatbot}
                                                alt="test"
                                                className="avenuicon"
                                              />
                                            </div>
                                          </div>
                                          <span class="time_date-right">
                                            {moment(item?.created_at).format(
                                              "DD MMM"
                                            )}
                                            . {item?.created_at?.slice(-8)} via{" "}
                                            {item?.platform}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>

                            <div className="chathead">
                              <div className="form-group">
                                <input
                                  placeholder="Send a message"
                                  className="form-control mesg-cht"
                                  value={textMessage}
                                  rows={2}
                                  onChange={(e) =>
                                    setTextMessage(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      sendMessage(profileDetails?.id);
                                    }
                                  }}
                                />
                                <button class="msg_send_btn" type="button">
                                  <img
                                    src={Send}
                                    alt="test"
                                    className="send_icon"
                                    onClick={() => {
                                      sendMessage(profileDetails?.id);
                                    }}
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                          {/* ) : (
                            <h4 className="mx-3 no-msg">
                              No Conversations Found
                            </h4>
                          )} */}
                        </TabPanel>

                        <TabPanel className="pr-3">
                          {chatbotsAnwers?.answers?.length !== 0 ? (
                            <div className="chat iner-sc conv-sc candScroll scrlHe-tab scroll1">
                              <div className="wrapp">
                                {chatbotsAnwers?.answers?.map((item) => {
                                  return (
                                    <div className="chatarea">
                                      <div className="replay">
                                        <div className="replayav">
                                          <div className="chatProf">
                                            <img
                                              src={AvenuChatbot}
                                              alt="test"
                                              className="avenuicon"
                                            />
                                          </div>
                                          <div className="chat-content chat-content-bg">
                                            <p
                                              style={{
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.question_text
                                                  .replace(
                                                    "{name}",
                                                    chatbotsAnwers?.replace_to_name
                                                  )
                                                  .replace(
                                                    "{method} ",
                                                    chatbotsAnwers?.replace_to_method
                                                  )
                                                  .replace(
                                                    "{method}",
                                                    chatbotsAnwers?.replace_to_method
                                                  ),
                                              }}
                                            ></p>
                                          </div>
                                        </div>
                                      </div>
                                      {item.answer_text !== "" && (
                                        <div className="replay request">
                                          <div className="replayav">
                                            <div className="chat-content chat-content-bg2">
                                              <p
                                                style={{
                                                  textOverflow: "ellipsis",
                                                  overflow: "hidden",
                                                }}
                                              >
                                                {item.answer_text}
                                              </p>
                                            </div>
                                            {/* <div className="chatProf">
                                              <img
                                                src={Avatar}
                                                alt="test"
                                                className="usericon"
                                              />
                                              </div> */}
                                            <div
                                              className="avatar"
                                              style={{
                                                backgroundColor: "#41D1FF",
                                              }}
                                            >
                                              {getAvatar(
                                                profileDetails?.first_name
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>

                              {/* {chatbotsAnwers?.length !== 0 && <div className='chathead'>
                                                              <div className='form-group'>
                                                                  <textarea placeholder='Send a message' className='form-control' rows={2} ></textarea>
                                                                  <img src={Send} alt="test" className="send_icon" onClick={click} />
                                                              </div>

                                                          </div>} */}
                            </div>
                          ) : (
                            <h4 className="mx-3 no-msg">
                              No Conversations Found
                            </h4>
                          )}
                        </TabPanel>
                      </div>
                    </Tabs>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={addCandidateOpen}>
        <div className="modal-header add-bottoms">
          <h5 className="modal-title">
            {isMyTeamPage ? "Add Employee" : "Add Candidate"}
          </h5>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setAddCandidateOpen(false);
              setError(false);
              setEmailError(false);
              setPhoneErr(false);
              setPhoneExist(false);
              setCandidateFirstname("");
              setCandidateLastname("");
              setCandidatePhone("");
              setCandidateEmail("");
            }}
          ></button>
        </div>
        <div className="modal-body addCand pb-0">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group form-group-default mt-0 mb-4 alertField">
                <label className="form-label name-size ">
                  First Name:<span className="stars">*</span>
                </label>
                <input
                  type="text"
                  placeholder="First Name"
                  value={candidateFirstName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits and the plus symbol
                    const regex = /^[A-Za-z]*$/;

                    if (regex.test(value)) {
                      setCandidateFirstname(value);
                    }
                  }}
                  className="form-control"
                ></input>
                {error && candidateFirstName.trim() === "" ? (
                  <p className="alertLeft">enter first name</p>
                ) : null}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group form-group-default mt-0 mb-3 alertField">
                <label className="form-label name-size">
                  Last Name: <span className="stars">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="form-control"
                  value={candidateLastName}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits and the plus symbol
                    const regex = /^[A-Za-z]*$/;

                    if (regex.test(value)) {
                      setCandidateLastname(value);
                    }
                  }}
                ></input>
                {error && candidateLastName.trim() === "" ? (
                  <p className="alertRight">enter last name</p>
                ) : null}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group form-group-default mt-0 mb-3 alertField">
                <label className="form-label  name-size">
                  Email Address: <span className="stars">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Email Address"
                  className="form-control"
                  value={candidateEmail}
                  onChange={(e) => setCandidateEmail(e.target.value)}
                  onBlur={(e) => {
                    emailValidate(null, e.target.value);
                  }}
                />
                {error && candidateEmail === "" ? (
                  <p className="alertLeft">enter email</p>
                ) : null}
                {emailError ? (
                  <p className="alertLeft">email already exists</p>
                ) : null}
                {!isEmailValid ? (
                  <p className="alertLeft">enter a valid email</p>
                ) : null}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group form-group-default mt-0 mb-3 alertField">
                <label className="form-label name-size">
                  Phone number:<span className="stars">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Phone number"
                  className="form-control"
                  value={candidatePhone}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits and the plus symbol
                    const regex = /^[0-9+]*$/;

                    if (regex.test(value)) {
                      setCandidatePhone(value);
                    }
                  }}
                  onBlur={(e) => {
                    validatePhone(e.target.value);
                  }}
                ></input>
                {error && candidatePhone === "" ? (
                  <p className="alertRight">enter phone number</p>
                ) : null}
                {phoneExist ? (
                  <p className="alertLeft">phone number already exists</p>
                ) : null}
                {phoneErr ? (
                  <p className="alertRight">enter a valid phone number</p>
                ) : null}
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group mt-0 mb-2 alertField">
                <label
                  className="form-label job-text mb-1"
                  style={{ fontSize: "14px" }}
                >
                  Job Applied:<span className="stars-jobs">*</span>
                </label>
                <div className="select">
                  <select
                    className="form-select "
                    value={candidateJobId}
                    onChange={(e) => {
                      setCandidateJobId(e.target.value);
                      // setTimeout(() => {
                      emailValidate(e.target.value, candidateEmail);
                      phoneValidate(e.target.value, candidatePhone);
                      // }, 1000)
                    }}
                  >
                    {jobs.map((item) => {
                      return (
                        <option value={item.id}>{item.chatbot_name}</option>
                      );
                    })}
                  </select>
                </div>
                {/* {formErr && (
                  <p className="alertLeft">No Valid Onboarding Forms !</p>
                )} */}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer footer-marg m-0">
          {/* <div className='col-lg-6'>
                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                <label className="send-job-check"> Send Job Application</label></div> */}

          <div className="col-lg-12 text-end">
            <button
              type="button"
              className=" Cancel-pop"
              onClick={() => {
                setAddCandidateOpen(false);
                setError(false);
                setEmailError(false);
                setPhoneErr(false);
                setPhoneExist(false);
                setCandidateFirstname("");
                setCandidateLastname("");
                setCandidatePhone("");
                setCandidateEmail("");
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary Add-pop mx-3"
              onClick={() => {
                loader === false && addCandidate();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>

      {/*---pv---*/}
      <Modal isOpen={isConversationModalOpen} className="conversation-modal">
        {/*  <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Modal Header</h4>
        </div>
        <div class="modal-body">
          <p>Some text in the modal.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>*/}
        <div className="modal-width">
          <h2 class="text-right text-xl modal-text">
            <h4 class="text-right text-xl modal-text-blue ml-3">
              Application form for {profileDetails?.chatbot?.chatbot_name} in
              Avenu{" "}
            </h4>
            <button
              onClick={() => {
                setIsConversationModalOpen(false);
              }}
              className="close-bttn "
            >
              <img
                src={closex}
                alt="close"
                className="create-icon mb-0 me-2 modal-close"
              />
            </button>
          </h2>
          <hr />
          <div
            className="modal-padding-pause scrlHe-tab scroll scroll1 "
            style={{ height: "82vh", width: "100%" }}
          >
            <div className="modal-text-textarea ">
              <div className="scrol-app">
                <div className="borders-part">
                  <p className="pop-app">
                    <span className="bold-name">Application Date :</span>{" "}
                    {conversationModalData?.created_at}
                  </p>
                  <p className="pop-app">
                    <span className="bold-name">Name :</span>{" "}
                    {profileDetails?.first_name}
                  </p>
                  <p className="pop-app">
                    <span className="bold-name">Email :</span>{" "}
                    {profileDetails?.email}
                  </p>
                  <p className="pop-app">
                    <span className="bold-name">Phone :</span>{" "}
                    {profileDetails?.phone}
                  </p>
                  <p className="pop-app">
                    <span className="bold-name">score :</span>{" "}
                    {profileDetails?.score}
                  </p>
                </div>
                {conversationModalData?.conversation?.answers?.length !== 0 && (
                  <h4 class="text-right text-xl modal-text-blue mt-3">
                    Conversations
                  </h4>
                )}
                {conversationModalData?.conversation?.answers?.length !== 0 && (
                  <div class="mesgs">
                    {conversationModalData?.conversation?.answers?.map(
                      (item) => {
                        return (
                          <div class="msg_history">
                            <div class="incoming_msg">
                              <div class="incoming_msg_img">
                                <img
                                  src={Grouplogo}
                                  alt="test"
                                  className="menu_icon"
                                />
                              </div>
                              <div class="received_msg">
                                <div class="received_withd_msg">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: item.question_text
                                        .replace(
                                          "{name}",
                                          chatbotsAnwers?.replace_to_name
                                        )
                                        .replace(
                                          "{method} ",
                                          chatbotsAnwers?.replace_to_method
                                        )
                                        .replace(
                                          "{method}",
                                          chatbotsAnwers?.replace_to_method
                                        ),
                                    }}
                                  ></p>
                                  <span class="time_date"> 11:01 AM </span>
                                </div>
                              </div>
                            </div>
                            {item?.answer_text !== "" && (
                              <div class="outgoing_msg">
                                <div class="sent_msg">
                                  <p>{item?.answer_text}</p>
                                  <span class="time_date"> 11:01 AM </span>{" "}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }
                    )}
                    {/* <div class="type_msg">
            <div class="input_msg_write">
              <input type="text" class="write_msg" placeholder="Type a message" />
              <button class="msg_send_btn" type="button"><i class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
            </div>
          </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/*<div className=" modal-check-bttn">
              <div class="row">
                <div class="col-sm-6">
                 
                </div>
                <div class="col-sm-6">
                  <button
                    className="update-btn-archive rounded p-2 "
                   
                  >
                    Yes
                  </button>
                  <button
                    className=" p-2  Cancel-pop"
                   
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>*/}
        </div>
      </Modal>
      {/*---pv---*/}

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={showResetModal}
          onRequestClose={() => {
            setShowResetModal(false);
          }}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Restart progress?
            </h2>
            <button
              onClick={() => {
                setShowResetModal(false);
              }}
              className="modal-close"
            >
              <img src={closex} alt="close" className="close-icon" />
            </button>
            <hr />
            <div className="modal-text1 text-marg">
              By this action, Candidate will need to refill all the forms. Any
              personalisation done will be reset to default template. Are you
              sure you want to proceed?
            </div>
            <div className=" modal-check-bttn">
              <div>
                <div class="col-lg-12 px-1 mb-4">
                  <div class="form-group mt-0 mb-2 alertField">
                    <label class="form-label job-text mb-1">
                      Select Onboarding template:
                    </label>
                    <div class="select">
                      <select
                        class="form-select "
                        onChange={(e) => {
                          setTemplateId(e.target.value);
                        }}
                      >
                        <option value="0">Select</option>
                        {onboardingTemplates.map((item) => {
                          return (
                            <option value={item?.id}>
                              {item?.template_name}
                            </option>
                          );
                        })}
                      </select>
                      <i className="mt-3">
                        <small>
                          Selection is not necessary if you wish to send the
                          onboarding set for this job.
                        </small>
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="q-btns mt-0 mb-3 d-flex justify-content-end modal-bttn footer-bttn">
              <div className="form-check me-3 ms-2 ps-0">
                {/* <div className='resetpopup'>
                                                    <input type="checkbox" name="check1" value="check" />
                                                    <label className='resetchk-text'>Do not show again</label>

                                                </div> */}
              </div>
              <button
                className="yes-btn rounded p-2"
                onClick={() => resetOnboarding()}
              >
                Yes
              </button>
              <p
                className="cancel-bttn ms-2"
                onClick={() => {
                  setShowResetModal(false);
                }}
              >
                Cancel
              </p>
            </div>
          </div>
        </Modal>
      </div>

      <Modal
        isOpen={isDeletePopupOpen}
        onRequestClose={() => {
          setIsDeletePopupOpen(false);
        }}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="modal-width">
          <h2 className="text-right text-xl modal-text">
            <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
            Delete Document
          </h2>

          <button
            onClick={() => {
              setIsDeletePopupOpen(false);
            }}
            className="modal-close"
          >
            {" "}
            <img src={closex} alt="copy" className="create-icon mb-0 me-2" />
          </button>
          <hr />
          <div className="modal-delect-text txtFonts">
            Are you sure you want to delete{" "}
            {deletePopupData?.name !== undefined
              ? deletePopupData?.name?.split("_")?.pop()
              : deletePopupData?.answer_text?.split("_")?.pop()}
            ?
          </div>

          <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
            <button
              className="yes-btn rounded p-2"
              onClick={() => {
                deleteDoc(deletePopupData?.id);
              }}
            >
              {" "}
              Yes{" "}
            </button>
            <p
              className="cancel-bttn"
              onClick={() => {
                setIsDeletePopupOpen(false);
              }}
            >
              {" "}
              Cancel{" "}
            </p>
          </div>
        </div>
      </Modal>
      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={showAlert}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img
                src={
                  newStatus === "onboarding" || newStatus === "resendonboarding"
                    ? onboardingimage
                    : newStatus === "rejected"
                    ? rejectimage
                    : newStatus === "paused"
                    ? pauseimage
                    : newStatus === "resumed"
                    ? resumeimage
                    : null
                }
                alt="copy"
                className="create-icon mb-0 me-2"
              />
              {newStatus === "resendonboarding"
                ? "Resend Onboarding"
                : newStatus === "onboarding"
                ? "Send Onboarding"
                : newStatus === "rejected"
                ? "Cancel Onboarding"
                : newStatus === "paused"
                ? "Pause Onboarding"
                : newStatus === "resumed"
                ? "Resume Onboarding"
                : null}
              <button
                onClick={() => {
                  setShowAlert(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="modal-padding-pause">
              <div className="modal-text-textarea">
                <textarea
                  className="pause-txt"
                  placeholder={
                    newStatus === "onboarding"
                      ? "Add an optional message for Sending Onboarding"
                      : newStatus === "rejected"
                      ? "Add an optional message for Cancelling Onboarding"
                      : "Add an optional message for Pausing Onboarding"
                  }
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                ></textarea>

                {/* <p className='onboard-text-popup'>{`If you have any questions, please contact .
                        ${currentStatus === 'onboarding' ? 'Onboarding' : currentStatus === 'rejected' ? 'Rejected' : 'Paused'} 
                        to 
                        ${newStatus === 'onboarding' ? 'Onboarding' : newStatus === 'rejected' ? 'Rejected' : 'Paused'}
                        `}</p> */}
              </div>
            </div>

            <div className=" modal-check-bttn">
              {/*<p
                className="cancel-bttn-onbord"
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                {" "}
                Back to Hired
              </p>
              <p
                className="cancel-bttn-onbord"
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                {" "}
                Don’t Send
              </p>*/}
              {newStatus === "onboarding" && (
                <div>
                  <div class="col-lg-12 px-1 mb-4">
                    <div class="form-group mt-0 mb-2 alertField">
                      <label class="form-label job-text mb-1">
                        Select Onboarding template:
                      </label>
                      <div class="select">
                        <select
                          class="form-select "
                          onChange={(e) => {
                            setTemplateId(e.target.value);
                          }}
                        >
                          <option value="0">Select</option>
                          {onboardingTemplates.map((item) => {
                            return (
                              <option value={item?.id}>
                                {item?.template_name}
                              </option>
                            );
                          })}
                        </select>
                        <i className="mt-3">
                          <small>
                            Selection is not necessary if you wish to send the
                            onboarding set for this job.
                          </small>
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div class="row">
                <div class="col-sm-6">
                  {(newStatus === "paused" || newStatus === "rejected") && (
                    <label>
                      <input
                        type="checkbox"
                        className="check-space"
                        checked={mailStatus}
                        onChange={() => {
                          setMailStatus(!mailStatus);
                        }}
                      />
                      Notify the applicant
                    </label>
                  )}
                </div>
                <div class="col-sm-3"></div>
                <div class="col-sm-3">
                  <button
                    className="update-btn rounded p-2 "
                    onClick={() => {
                      updateStatus(0);
                    }}
                  >
                    {newStatus === "onboarding" ? "Send" : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={isMultipleChangeModalOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img
                src={
                  newStatus === "onboarding" || newStatus === "resendonboarding"
                    ? onboardingimage
                    : newStatus === "rejected"
                    ? rejectimage
                    : newStatus === "paused"
                    ? pauseimage
                    : newStatus === "resumed"
                    ? resumeimage
                    : newStatus === "myteam"
                    ? Archive
                    : null
                }
                alt="copy"
                className="create-icon mb-0 me-2"
              />
              {newStatus === "resendonboarding"
                ? "Resend Onboarding"
                : newStatus === "onboarding"
                ? "Send Onboarding"
                : newStatus === "rejected"
                ? "Cancel Onboarding"
                : newStatus === "paused"
                ? "Pause Onboarding"
                : newStatus === "resumed"
                ? "Resume Onboarding"
                : newStatus === "myteam"
                ? "Add Employees to My Team?"
                : null}
              <button
                onClick={() => {
                  setIsMultipleChangeModalOpen(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="modal-padding-pause">
              <div className="modal-text-textarea">
                <textarea
                  className="pause-txt"
                  placeholder={
                    newStatus === "onboarding"
                      ? "Add an optional message for Sending Onboarding"
                      : newStatus === "rejected"
                      ? "Add an optional message for Cancelling Onboarding"
                      : "Add an optional message for Pausing Onboarding"
                  }
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                ></textarea>

                {/* <p className='onboard-text-popup'>{`If you have any questions, please contact .
                        ${currentStatus === 'onboarding' ? 'Onboarding' : currentStatus === 'rejected' ? 'Rejected' : 'Paused'} 
                        to 
                        ${newStatus === 'onboarding' ? 'Onboarding' : newStatus === 'rejected' ? 'Rejected' : 'Paused'}
                        `}</p> */}
              </div>
            </div>

            <div className=" modal-check-bttn">
              {/*<p
                className="cancel-bttn-onbord"
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                {" "}
                Back to Hired
              </p>
              <p
                className="cancel-bttn-onbord"
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                {" "}
                Don’t Send
              </p>*/}

              <div class="row">
                <div class="col-sm-6">
                  {(newStatus === "paused" || newStatus === "rejected") && (
                    <label>
                      <input
                        type="checkbox"
                        className="check-space"
                        checked={mailStatus}
                        onChange={() => {
                          setMailStatus(!mailStatus);
                        }}
                      />
                      Notify the applicant
                    </label>
                  )}
                </div>
                <div class="col-sm-3"></div>
                <div class="col-sm-3">
                  <button
                    className="update-btn rounded p-2 "
                    onClick={() => {
                      updateStatus(1);
                    }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={archiveModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              {/* <img
                src={(newStatus === "onboarding" || newStatus === "resendonboarding")
                  ? onboardingimage
                  : newStatus === "rejected"
                    ? rejectimage
                    : newStatus === "paused"
                      ? pauseimage
                      : newStatus === "resumed"
                        ? resumeimage
                        : null
                }
                alt="copy"
                className="create-icon mb-0 me-2"
              /> */}
              <h2 class="text-right text-xl modal-text">
                <img
                  src={Archive}
                  alt="copy"
                  className="create-icon mb-0 me-2"
                />
                {newStatus === "archive"
                  ? "Archive Employee"
                  : newStatus === "unarchive"
                  ? "Unarchive Employee"
                  : newStatus === "myteam"
                  ? "Add Employee To My Team"
                  : null}
              </h2>
              <button
                onClick={() => {
                  setArchiveModal(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="modal-padding-pause">
              <div className="modal-text-textarea">
                {/* <textarea
                  className="pause-txt"
                  placeholder={
                    newStatus === "onboarding"
                      ? "Add an optional message for Sending Onboarding"
                      : newStatus === "rejected"
                        ? "Add an optional message for Cancelling Onboarding"
                        : "Add an optional message for Pausing Onboarding"
                  }
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                ></textarea> */}

                <p className="archi-text">{message}</p>
              </div>
            </div>

            <div className=" modal-check-bttn">
              <div class="row">
                <div class="col-sm-6">
                  {/* <label className="archi-labels">
                    <input type="checkbox" className="check-space"  />Do not show again
                  </label> */}
                </div>
                <div class="col-sm-6">
                  <button
                    className="update-btn-archive rounded p-2 "
                    onClick={() => {
                      newStatus === "archive"
                        ? archiveEmployee(0)
                        : updateStatus(0);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    className=" p-2  Cancel-pop"
                    onClick={() => {
                      setArchiveModal(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={isMultipleArchiveModalOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              {/* <img
                src={(newStatus === "onboarding" || newStatus === "resendonboarding")
                  ? onboardingimage
                  : newStatus === "rejected"
                    ? rejectimage
                    : newStatus === "paused"
                      ? pauseimage
                      : newStatus === "resumed"
                        ? resumeimage
                        : null
                }
                alt="copy"
                className="create-icon mb-0 me-2"
              /> */}
              <h2 class="text-right text-xl modal-text">
                <img
                  src={Archive}
                  alt="copy"
                  className="create-icon mb-0 me-2"
                />
                {newStatus === "archive"
                  ? "Archive Employee"
                  : newStatus === "unarchive"
                  ? "Unarchive Employee"
                  : newStatus === "myteam"
                  ? "Add Employee To My Team"
                  : null}
              </h2>
              <button
                onClick={() => {
                  setIsMultipleArchiveModalOpen(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="modal-padding-pause">
              <div className="modal-text-textarea">
                {/* <textarea
                  className="pause-txt"
                  placeholder={
                    newStatus === "onboarding"
                      ? "Add an optional message for Sending Onboarding"
                      : newStatus === "rejected"
                        ? "Add an optional message for Cancelling Onboarding"
                        : "Add an optional message for Pausing Onboarding"
                  }
                  value={message}
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                ></textarea> */}

                <p className="archi-text">{message}</p>
              </div>
            </div>

            <div className=" modal-check-bttn">
              <div class="row">
                <div class="col-sm-6">
                  {/* <label className="archi-labels">
                    <input type="checkbox" className="check-space"  />Do not show again
                  </label> */}
                </div>
                <div class="col-sm-6">
                  <button
                    className="update-btn-archive rounded p-2 "
                    onClick={() => {
                      newStatus === "archive"
                        ? archiveEmployee(1)
                        : updateStatus(1);
                    }}
                  >
                    Yes
                  </button>
                  <button
                    className=" p-2  Cancel-pop"
                    onClick={() => {
                      setIsMultipleArchiveModalOpen(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={isSendForm}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img
                src={onboardingimage}
                alt="copy"
                className="create-icon mb-0 me-2"
              />
              Send Forms
              <button
                onClick={() => {
                  setIsSendForms(false);
                }}
                className="close-bttn "
              >
                <img
                  src={closex}
                  alt="close"
                  className="create-icon mb-0 me-2 modal-close"
                />
              </button>
            </h2>
            <hr />
            <div className="modal-padding-pause">
              <div className="modal-text-textarea">
                <textarea
                  className="pause-txt"
                  placeholder="Add an optional message for Sending Forms"
                  value={sendFormMessage}
                  onChange={(e) => {
                    setSendFormMessage(e.target.value);
                  }}
                ></textarea>
              </div>
            </div>

            <div className=" modal-check-bttn">
              <div>
                <div class="col-lg-12 px-1 mb-4">
                  <div class="form-group mt-0 mb-2 alertField">
                    <label class="form-label job-text mb-1">
                      Select template:
                    </label>
                    <div class="select">
                      <select
                        class="form-select "
                        style={{
                          border: templateId === 0 ? "1px solid red" : null,
                        }}
                        onChange={(e) => {
                          setTemplateId(e.target.value);
                        }}
                      >
                        <option value="0">Select</option>
                        {onboardingTemplates.map((item) => {
                          return (
                            <option value={item?.id}>
                              {item?.template_name}
                            </option>
                          );
                        })}
                      </select>
                      <i className="mt-3">
                        <small>
                          Selection is necessary if you wish to send form to
                          candidates.
                        </small>
                      </i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  {(newStatus === "paused" || newStatus === "rejected") && (
                    <label>
                      <input
                        type="checkbox"
                        className="check-space"
                        checked={mailStatus}
                        onChange={() => {
                          setMailStatus(!mailStatus);
                        }}
                      />
                      Notify the applicant
                    </label>
                  )}
                </div>
                <div class="col-sm-3"></div>
                <div class="col-sm-3">
                  <button
                    className="update-btn rounded p-2 "
                    onClick={() => {
                      sendForms(0);
                    }}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        {/* <button onClick={openModal} className="bg-white px-4 py-3 rounded border-2 shadow-md shadow-red-600 hover:bg-gray-200">Open Modal</button> */}

        <Modal
          isOpen={deleteSectionModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Section
            </h2>

            <button
              onClick={() => {
                setSectionDeleteModal(false);
              }}
              className="modal-close"
            >
              {" "}
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete {modalData?.itemName}?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteSection(modalData.itemId);
                }}
              >
                {" "}
                Yes{" "}
              </button>

              <p
                className="cancel-bttn"
                onClick={() => {
                  setSectionDeleteModal(false);
                }}
              >
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Approve Candidate
            </h2>

            <button onClick={closeModal} className="modal-close">
              {" "}
              <img src={closex} alt="copy" className="create-icon mb-0 me-2" />
            </button>
            <hr />
            <div className="modal-text1">
              {!isMyTeamPage
                ? "Approve will move this candidate to My Team."
                : "Are you sure you want to approve all the submitted documents?"}
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  reviewCandidate();
                }}
              >
                {" "}
                OK{" "}
              </button>
              <p className="cancel-bttn" onClick={closeModal}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>
      {/* for showing toast */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loader && <Spinner />}
      {miniLoader && <MiniSpinner />}
    </div>
  );
};

export default AllApplications;
